var GRID_SHOW_INSERT = true;
var GRID_SHOW_DELETE = true;
let ZEEV_FORM_FIELDS = [];

var execv = {
    util: {}
};

execv.util.rewriteConcatToText = function (s) {
    s = s.replace(/!@!/g, ',');
    s = s.replace(/\$@\$/g, ';');
    s = s.replace(/"/g, '\\');
    return s;
}

execv.util.sanitizeTextToConcat = function (s) {
    s = s.replace(/\\/g, '"');
    return s;
}

execv.util.isAlphanumericCnpjMask = function (mask) {
    return mask && /\*{2}\.\*{3}\.\*{3}\/\*{4}-(##|99)/.test(mask);
}

// inicio - leonardo 20/08/2008
var REQUIRED_FILES_LIST_INPUT = "inpDsFileList";
var ONLY_REQUIRED_FILE_INPUT = "inpStOnlyRequiredFile";

function isEmpty(object) {
    return String(object) == "" || object == null || typeof (object) == "undefined";
}

function getObject(objectName, source) {
    if (isEmpty(objectName)) {
        return null;
    }
    if (isEmpty(source)) {
        source = self;
    }
    //Check if the source is a reference or a name
    if (source.substring) {
        //It's a name. Try to find it on a frame
        sourceName = source;
        source = self.frames[sourceName];
        if (source === undefined) source = parent.frames[sourceName];
        if (source === undefined) source = top.frames[sourceName];
        if (source === undefined) source = getObject(sourceName);
        if (source === undefined) return null;
    }
    //Get the document
    var document = (source.document) ? source.document : source;
    //Check the browser's type

    //Netscape
    if (document.getElementById(objectName)) return document.getElementById(objectName);
    var collection = document.getElementsByName(objectName);
    if (collection.length == 1) return collection[0];
    if (collection.length > 1) return collection;

    return null;
}

function getSiblings(el, filter) {
    var siblings = [];
    el = el.parentNode.firstChild;
    do { if (!filter || filter(el)) siblings.push(el); } while (el = el.nextSibling);
    return siblings;
}

// verificar se foram anexadas a mesma quantidade de arquivos que foi definida na tarefa como obrigatórios
function attachedFiles() {
    var msg = validateFileTypes();
    if (!msg.length)
        return true;
    else
        cryo_alert(mlMsgValidationErrors + "\n" + msg);
}

function compareValueWithIndex(val, index) {
    return val === j;
}

// valida se apenas os arquivos obrigatórios estao anexados
function validateFileTypes() {
    var requiredFile = [];
    if ($('#inpCodBre').val() == 0) {
        requiredFile = getObj(REQUIRED_FILES_LIST_INPUT).value.split("\n");
    } else {
        captureModule.vars.docList.forEach(function (val) {
            requiredFile[requiredFile.length] = val.Nome;
        });
    }

    var onlyRequiredFile = getObj(ONLY_REQUIRED_FILE_INPUT).value;

    var filesNotRequired = [];
    var filesNotFound = [];
    var filesValidate = [];
    var msg = [];
    for (var i = 0; i < $('[name=inpDsFileName]').length; i++) {
        var dsfileNameField = document.getElementsByName("inpDsFileName")[i];
        var file = dsfileNameField.value.split(';');
        var doctype = execv.util.rewriteConcatToText(file[5]);
        if (doctype === undefined || doctype === '') {
            filesNotRequired[filesNotRequired.length] = file[0];
            dsfileNameField.value = execv.util.sanitizeTextToConcat(dsfileNameField.value);
            continue;
        }

        var fileFound = false;
        for (var j = 0; j < requiredFile.length; j++) {
            if (requiredFile[j].trim().length > 0) {
                if (requiredFile[j].toUpperCase().trim() === doctype.toUpperCase().trim() && !filesValidate.some(compareValueWithIndex)) {
                    filesValidate[filesValidate.length] = j;
                    fileFound = true;
                    break;
                }
            }
        }
        if (!fileFound)
            filesNotRequired[filesNotRequired.length] = doctype;

        dsfileNameField.value = execv.util.sanitizeTextToConcat(dsfileNameField.value);
    }

    document.querySelectorAll(".docType").forEach(function (item) {
        var fileName = item.innerText.trim();
        var fileIndex = requiredFile.indexOf(fileName);
        if (fileIndex !== -1) {
            filesValidate.push(fileIndex);
        }
    });

    for (var k = 0; k < requiredFile.length; k++) {
        if (requiredFile[k].trim().length > 0) {
            if (!filesValidate.some(function (val, index) { return val === k; }))
                filesNotFound[filesNotFound.length] = requiredFile[k];
        }
    }

    if (onlyRequiredFile === 'True')
        filesNotRequired.forEach(function (e, i, a) {
            msg[msg.length] = '\n' + e + ': ' + mlMsgDocumentNotRequired;
        });

    filesNotFound.forEach(function (e, i, a) {
        msg[msg.length] = '\n' + e + ': ' + mlMsgDocumentNotAttached;
    });

    return msg;
}

// conta a quantidade de arquivos anexados na tarefa
function countAttachedFiles() {
    return $('.delFile').length;
}

// conta a quantidade de arquivos que devem ser anexados à tarefa
function countNumberOfFilesToAttach() {
    var files = getObj(REQUIRED_FILES_LIST_INPUT);
    var lines = files.value.split("\n");
    var i;
    var numberOfLines = 0;
    for (i = 0; i < lines.length; i++) {
        if (lines[i].length > 1) {
            numberOfLines++;
        }
    }
    return numberOfLines;
}
// fim - 20/08/2008

function messageWaiting() {
    var ms = $("#inpDsMessage");
    if (ms !== null && ms.length > 0 && ms.val() != ms.prop('placeholder') && ms.val() !== "") {
        return (confirm(mlMsgMessageWarning));
    }
    return true;
}

function validateLogHours() {
    var inpNbLogHours = getObj("inpNbLogHours");
    if (inpNbLogHours !== null && inpNbLogHours.required == true) {
        if (inpNbLogHours.value !== undefined && (inpNbLogHours.value === "" || inpNbLogHours.value === inpNbLogHours.placeholder)) {
            cryo_alert(mlMsgLogHoursRequired);
            return false;
        } else {
            incrementNbLogMinutes();
        }
    }
    return true;
}

function finishSend() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    hasChangeAnyValue = false;
    cryo_appOpenLoading();
    saveMessages();
    hideControllerBlock();
    getObj("inpAction").value = "ADD";
    getObj("inpCodFlowResult").value = "3";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    submitForm();
}

function send() {
    var validateResult, attachedFilesResult, signPostResult, messageWaitingResult, confirmResult, validateLogHoursResult, validateAdHocResult;

    validateResult = validate();
    checkListResult = verifyCheckList();

    if (validateResult && checkListResult) {
        attachedFilesResult = attachedFiles();
        //signPostResult = signPost();
        signPostResult = true;
        messageWaitingResult = messageWaiting();
        validateLogHoursResult = validateLogHours();
        validateAdHocResult = true;

        if (attachedFilesResult && signPostResult && messageWaitingResult && validateLogHoursResult && validateAdHocResult) {
            signPostResult = true;

            // nao marcou para assinar tarefa
            finishSend();
        }
    }

    return (validateResult && attachedFilesResult && signPostResult && messageWaitingResult && confirmResult && validateLogHoursResult && checkListResult);
}

function controlValueChange(o) {
    var v = getObj("inpCodChangedField").value;
    if (v != "") {
        v += ',' + o.name;
    } else {
        v += o.name;
    }
    getObj("inpCodChangedField").value = v;
}

function manipulate(a) {
    var i = 0;
    var reg = "";
    var ret = "";
    var x = [];
    var xTemp = [];
    var xFinal = [];

    reg = /"[a-zA-Z1-9:][^"]*\s.*?"/;
    while (reg.test(a)) {
        var ext = reg.exec(a);
        a = a.replace(ext[0], ext[0].replace(" ", ""));
    }

    a = replaceAll(a, ">", " > ");
    a = replaceAll(a, "<", " <");

    x = a.split(' ');
    for (i = 0; i < x.length; i++) {
        if (x[i] != "") {
            if (x[i].substring(0, 1) == "<") {
                xFinal = xFinal.concat(xTemp);
                xFinal[xFinal.length] = x[i];
                xTemp = [];
            } else if (x[i].substring(x[i].length - 1, 1) == ">") {
                xTemp.sort();
                xFinal = xFinal.concat(xTemp);
                xFinal[xFinal.length] = x[i];
                xTemp = [];
            } else {
                xTemp[xTemp.length] = x[i];
            }
        }
    }

    ret = xFinal.join("");
    ret = ret.toLowerCase();

    //data
    reg = new RegExp("oldValue\=\".*?\"", "gi");
    ret = ret.replace(reg, "");
    reg = new RegExp("typedChar\=\".*?\"", "gi");
    ret = ret.replace(reg, "");
    reg = new RegExp("mask\=\".*?\"", "gi");
    ret = ret.replace(reg, "");

    //padrão
    ret = replaceAll(ret, " ", "");
    ret = replaceAll(ret, "\"", "");
    ret = replaceAll(ret, "\n", "");
    ret = replaceAll(ret, "\r", "");

    //tbody de tabelas
    ret = replaceAll(ret, "<tbody>", "");
    ret = replaceAll(ret, "</tbody>", "");

    //retira espaco em branco html
    ret = replaceAll(ret, "&nbsp;", "");

    //retirar backgorund-image
    reg = new RegExp("style\=background-color:.......", "gi");
    ret = ret.replace(reg, "");

    //data
    ret = replaceAll(ret, "backspace=false", "");
    ret = replaceAll(ret, "clear=false", "");
    ret = replaceAll(ret, "pad=false", "");

    //retirar onfocus
    var t = /onfocus\=.*?\)/gi;
    reg = new RegExp(t);
    ret = ret.replace(reg, "");

    //retirar imagens
    reg = /<img[^>]*sign_small\.gif[^>]*?>/gi;
    ret = ret.replace(reg, "");

    //retirar celuluas botões (para caso do multline)
    reg = new RegExp("<td[^>]*><button[^>]*>.*?</button></td>", "gi");
    ret = ret.replace(reg, "");
    return ret;
}

function checkedSignatureInput() {
    var result = false;

    if (getObject("inpToSign") != null) {
        if (getObject("inpToSign").checked == true && $("input[name = inpToSign]").data("signType") !== "FI") {
            result = true;
        }
    }

    return result;
}

function signPost() {
    var result = true;

    if (checkedSignatureInput()) {
        // marcou para assinar a tarefa

        // 18/01/2012 - Leonardo - Início
        // Montagem da string a criptografar/assinar
        str = "";
        $("#BoxFrmExecute :input").each(function (key, val) {
            if (val.type != "checkbox" && val.type != "radio") {
                if ($(val).attr("name") !== undefined) {
                    str += "FillValue('" + $(val).attr("name").substring(3) + "','" + $(val).val() + "');";
                }
            }
            else {
                if ($(val).is(":checked")) {
                    if ($(val).attr("name") !== undefined) {
                        str += "FillValue('" + $(val).attr("name").substring(3) + "','" + $(val).val() + "');";
                    }
                }
            }
            return;
        });
        // 18/01/2012 - Leonardo - Fim

        // 13/12/2016 - Leonardo Luzzatto - Bug 30696
        // Ao concluir uma tarefa usando certificado digital, se a tarefa possuir informações com quebras de
        // linhas (textarea) então não é possível concluir a tarefa. Mensagem de erro:
        // Os dados pessoais do Certificado Digital utilizado diferem do seu cadastro de usuário deste sistema.
        str = str.replace(/\n/gi, '');

        getObject("inpDsSignedData").value = str;

        // testar se tem algum conteudo a assinar
        if (typeof String.prototype.trim === 'function') {
            if (str === undefined || str.trim() === "") {
                result = false;
            }
        } else {
            if (str === undefined || str === "") {
                result = false;
            }
        }
    }

    return result;
}

function finishApprove() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    hasChangeAnyValue = false;
    cryo_appOpenLoading();
    cancelUnClaim();
    hideControllerBlock();
    getObj("inpAction").value = "UPDATE";
    getObj("inpCodFlowResult").value = "1";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    getObj("frm").method = "POST";
    submitForm();
}

function approve() {
    var validateResult, attachedFilesResult, messageWaitingResult, confirmResult, validateLogHoursResult, validateAdHocResult, signPostResult;
    // esconde box de não-conclusão e limpa texto
    hideAndClearReasonBoxes();

    validateResult = validate();
    checkListResult = verifyCheckList();

    if (validateResult && checkListResult) {
        attachedFilesResult = attachedFiles();

        messageWaitingResult = messageWaiting();
        validateLogHoursResult = validateLogHours();
        validateAdHocResult = true;

        if (attachedFilesResult && messageWaitingResult && validateLogHoursResult && validateAdHocResult) {
            cryo_confirm(mlMsgConfirmTaskApproval, mlTitleApproveTask, mlLblApprove, function () {
                signPostResult = true;
                // nao marcou para assinar tarefa
                finishApprove();
            }, (!checkedSignatureInput()));
        }
    }

    return (validateResult && attachedFilesResult && signPostResult && messageWaitingResult && confirmResult && validateLogHoursResult && checkListResult);
}

function cryo_appOpenLoading() {
    if ('app' in window) {
        app.UI.overlay.open(true);
    }
}

function cancelUnClaim() {
    cryo_TaskUnclaimOwnershipWrapperOld = cryo_TaskUnclaimOwnershipWrapper;
    cryo_TaskUnclaimOwnershipWrapper = function () { /* cancela o evento de Desapropriar a tarefa */ };
}

function finishDoAction() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    cryo_appOpenLoading();
    hasChangeAnyValue = false;
    hideControllerBlock();
    if (getObj("inpCodFlowExecuteTask").value != "") {
        getObj("inpAction").value = "UPDATE";
        cancelUnClaim();
    } else {
        getObj("inpAction").value = "ADD";
    }
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    getObj("frm").method = "POST";
    submitForm();
}

function doAction(action, mustValidate, mustInputReason) {
    var valid, files, sign, validateLogHoursResult, validateAdHocResult;

    getObj("inpCodFlowResult").value = "";
    getObj("inpDsFlowResult").value = action;

    // esconde box de não-conclusão e limpa texto
    hideAndClearReasonBoxes();

    if (mustInputReason) {
        if (mustValidate) {
            forceInputReasonWithValidation();
        } else {
            forceInputReasonNoValidation();
        }
    } else {
        valid = true;
        files = true;
        sign = true;
        checkListResult = true;
        validateAdHocResult = true;
        validateLogHoursResult = validateLogHours();
        if (mustValidate) {
            valid = validate();
            files = attachedFiles();
            checkListResult = verifyCheckList();
            // sign = signPost();
            validateAdHocResult = true;
        } else {
            saveMessages();
        }
        if (valid && checkListResult) {
            if (files && sign && messageWaiting() && validateLogHoursResult && validateAdHocResult) {
                cryo_confirm(mlMsgConfirmTaskClosure, mlTitleFinalizeTask, btnFinish, function () {
                    signPostResult = true;

                    // nao marcou para assinar tarefa
                    finishDoAction();
                }, (!checkedSignatureInput()));
            }
        }
    }
}

function doActionNotValidate(act, mustValidate, mustInputReason) {
    let messageWaitingResult, validateLogHoursResult;

    getObj("inpCodFlowResult").value = "";
    getObj("inpDsFlowResult").value = act;

    hideAndClearReasonBoxes();

    if (mustInputReason) {
        forceInputReasonNoValidation();
    } else {
        messageWaitingResult = messageWaiting();
        validateLogHoursResult = validateLogHours();
        const validatePositionAreaResult = validatePositionAreaCombo();

        checkListResult = true;

        if (messageWaitingResult && validateLogHoursResult && checkListResult && validatePositionAreaResult) {
            cryo_confirm(mlMsgConfirmTaskClosure, mlTitleFinalizeTask, btnFinish, function () {
                cryo_appOpenLoading();
                saveMessages();
                hideControllerBlock();
                if (getObj("inpCodFlowExecuteTask").value != "") {
                    getObj("inpAction").value = "UPDATE";
                } else {
                    getObj("inpAction").value = "ADD";
                }

                getObj("__VIEWSTATE").value = "";
                getObj("frm").action = getExecutionPage();
                getObj("frm").target = "ifrmProcess";
                getObj("frm").method = "POST";
                getObj("frm").submit();
            }, (!checkedSignatureInput()));

        }
    }

    return (messageWaitingResult && validateLogHoursResult && checkListResult);
}

function doActionSkippingConfirmation(action, mustValidate, mustInputReason) {
    var valid, files, sign, validateLogHoursResult, validateAdHocResult;

    getObj("inpCodFlowResult").value = "";
    getObj("inpDsFlowResult").value = action;

    // esconde box de não-conclusão e limpa texto
    hideAndClearReasonBoxes();

    if (mustInputReason) {
        if (mustValidate) {
            forceInputReasonWithValidation();
        } else {
            forceInputReasonNoValidation();
        }
    } else {
        valid = true;
        files = true;
        sign = true;
        checkListResult = true;
        validateAdHocResult = true;
        validateLogHoursResult = validateLogHours();
        if (mustValidate) {
            checkListResult = verifyCheckList();
            valid = validate();
            files = attachedFiles();
            validateAdHocResult = true;
        } else {
            saveMessages();
        }
        if (valid) {
            if (files && sign && messageWaiting() && validateLogHoursResult && validateAdHocResult) {
                signPostResult = true;

                // nao marcou para assinar tarefa
                finishDoAction();
            }
        }
    }
}

function reject() {
    $("#BoxRejection").show();
    if (clientIsMobile) location.href = "#reasonbox";
    $("#BoxForceInputReason").hide();
}

function forceInputReasonNoValidation() {
    var signPostResult, validateLogHoursResult;
    signPostResult = true;
    validateLogHoursResult = validateLogHours();
    if (signPostResult) {
        $("#BoxNotConclude").hide();
        $("#BoxRejection").hide();
        $("#BoxForceInputReason").show();
        $("#BtnConfirmReason").unbind('click');
        $("#BtnConfirmReason").click(confirmInputReasonNoValidation);
    }
    return (signPostResult && validateLogHoursResult);
}

function forceInputReasonWithValidation() {
    var signPostResult, validateLogHoursResult;
    signPostResult = true;
    validateLogHoursResult = validateLogHours();

    if (signPostResult) {
        $("#BoxNotConclude").hide();
        $("#BoxRejection").hide();
        $("#BoxForceInputReason").show();
        if (clientIsMobile) location.href = "#reasonbox";
        $("#BtnConfirmReason").unbind('click');
        $("#BtnConfirmReason").click(confirmInputReasonWithValidation);
    }
    return (signPostResult && validateLogHoursResult);
}

function finishRejection() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    hasChangeAnyValue = false;
    cancelUnClaim();
    cryo_appOpenLoading();
    hideControllerBlock();
    getObj("inpAction").value = "UPDATE";
    getObj("inpCodFlowResult").value = "2";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    submitForm();
}

function confirmRejection() {
    var validateResult, signPostResult, messageWaitingResult, validateLogHoursResult, validateAdHocResult;

    validateResult = validate();
    checkListResult = verifyCheckList();

    if (validateResult && checkListResult) {
        messageWaitingResult = messageWaiting();
        validateLogHoursResult = validateLogHours();
        validateAdHocResult = true;

        if (messageWaitingResult && validateLogHoursResult && validateAdHocResult) {
            signPostResult = true;
            finishRejection();
        }
    }

    return (validateResult && signPostResult && messageWaitingResult && validateLogHoursResult && checkListResult);
}

function confirmInputReasonNoValidation() {
    var SHOULD_NOT_VALIDATE = false;
    return confirmInputReason(SHOULD_NOT_VALIDATE);
}

function confirmInputReasonWithValidation() {
    var SHOULD_VALIDATE = true;
    return confirmInputReason(SHOULD_VALIDATE);
}

function finishConfirmInputReason() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    cryo_appOpenLoading();
    cancelUnClaim();
    hideControllerBlock();
    getObj("inpAction").value = "UPDATE";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    submitForm();
}

function confirmInputReason(mustValidate) {
    var valid, files, signPostResult, messageWaitingResult, validateLogHoursResult, validateAdHocResult;

    valid = true;
    files = true;
    validateAdHocResult = true;

    if (mustValidate) {
        valid = validate();
        files = attachedFiles();
        validateAdHocResult = true;
    }

    messageWaitingResult = messageWaiting();
    validateLogHoursResult = validateLogHours();

    if (valid && files && messageWaitingResult && validateLogHoursResult && validateAdHocResult) {
        // obrigar a preencher a justificativa
        if ($.trim($('#inpDsReasonInputReason').val()) === "") {
            cryo_alert(mlMsgValidationRequiredField.replace("{{field}}", $("#inpDsReasonInputReason").attr('label')));
            return false;
        }
        signPostResult = true;
        // nao marcou para assinar tarefa
        finishConfirmInputReason();
    }
    return (valid && files && signPostResult && messageWaitingResult && validateLogHoursResult);
}

function hideAndClearReasonBoxes() {
    $('#BoxNotConclude').hide();
    $('#BoxRejection').hide();
    $('#BoxForceInputReason').hide();
    $('#inpDsReason').val('');
    $('#inpDsReasonInputReason').val('');
}

function finishConclude() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    hasChangeAnyValue = false;
    cryo_appOpenLoading();
    cancelUnClaim();
    hideControllerBlock();
    getObj("inpAction").value = "UPDATE";
    getObj("inpCodFlowResult").value = "3";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    submitForm();
}

function conclude(options) {
    options = options || {
        doValidation: true,
        digitalFileSign: false
    };

    var validateResult, attachedFilesResult, signPostResult, messageWaitingResult, confirmResult, validateLogHoursResult, validateAdHocResult;

    // esconde box de não-conclusão e limpa texto
    hideAndClearReasonBoxes();

    if (options.doValidation === true)
        validateResult = validate();

    checkListResult = verifyCheckList();

    if ((options.doValidation === false || validateResult) && checkListResult) {
        attachedFilesResult = attachedFiles();
        messageWaitingResult = messageWaiting();
        validateLogHoursResult = validateLogHours();
        validateAdHocResult = true;

        if (attachedFilesResult && messageWaitingResult && validateLogHoursResult && validateAdHocResult) {
            cryo_confirm(mlMsgConfirmTaskClosure, mlTitleFinalizeTask, btnFinish, function () {
                signPostResult = true;

                // nao marcou para assinar tarefa
                finishConclude();
            }, (!checkedSignatureInput()));
        }
    }

    return (validateResult && attachedFilesResult && signPostResult && messageWaitingResult && confirmResult && validateLogHoursResult && checkListResult);
}

function concludeSkippingConfirmation(options) {
    options = options || {
        doValidation: true,
        digitalFileSign: false
    };

    var validateResult, attachedFilesResult, signPostResult, messageWaitingResult, confirmResult, validateLogHoursResult, validateAdHocResult;

    // esconde box de não-conclusão e limpa texto
    hideAndClearReasonBoxes();

    if (options.doValidation !== false)
        validateResult = validate();

    checkListResult = verifyCheckList();

    if ((options.doValidation === false || validateResult) && checkListResult) {
        attachedFilesResult = attachedFiles();
        messageWaitingResult = messageWaiting();
        validateLogHoursResult = validateLogHours();
        validateAdHocResult = true;

        if (attachedFilesResult && messageWaitingResult && validateLogHoursResult && validateAdHocResult) {
            signPostResult = true;

            // nao marcou para assinar tarefa
            finishConclude();
        }
    }

    return (validateResult && attachedFilesResult && signPostResult && messageWaitingResult && confirmResult && validateLogHoursResult && checkListResult);
}

function save(close) {
    if (close == null) close = true;
    var confirmResult;

    if (true) {//confirmResult) {
        hasChangeAnyValue = false;
        cancelUnClaim();
        cryo_appOpenLoading();
        hideControllerBlock();
        if (typeof ConcurrencyManager !== 'undefined') ConcurrencyManager.stopPolling();
        getObj("inpAction").value = (close ? "SAVEANDCLOSE" : "SAVE");
        getObj("__VIEWSTATE").value = "";
        getObj("frm").action = getExecutionPage();
        getObj("frm").target = "ifrmProcess";
        getObj("frm").submit();
    }

    return confirmResult;
}

function notConclude() {
    if (/*signPost() && */messageWaiting() && validateLogHours()) {
        $("#BoxNotConclude").show();
        if (clientIsMobile) location.href = "#reasonbox";
        $("#BoxForceInputReason").hide();
    }
}

function buildCustomButton(label, n, r) {
    var c = getObj("buttons");
    if (c != null && c != undefined) {
        if (r == null) {
            r = null;
        }
        var a = document.createElement("BUTTON");
        a.innerHTML = "<div>" + label + "</div>";
        a.className = "nivel1";
        a.onclick = function () {
            if (validate()) {
                if (signPost()) {
                    if (r) {
                        getObj("BoxRejection").style.display = "block";
                    } else {
                        if (confirm(mlMsgConfirmTaskClosure)) {
                            cryo_appOpenLoading();
                            hideControllerBlock();
                            if (getObj("inpCodFlowExecuteTask").value == "") {
                                getObj("inpAction").value = "ADD";
                            } else {
                                getObj("inpAction").value = "UPDATE";
                            }
                            getObj("inpCodFlowResult").value = n;
                            getObj("__VIEWSTATE").value = "";
                            getObj("frm").action = getExecutionPage();
                            getObj("frm").target = "ifrmProcess";
                            getObj("frm").submit();
                        }
                    }
                }
            }
        };
        c.appendChild(a);
    }
}

function finishNotConclude() {
    window.finishTask = true;
    window.clearInterval(window.isTaskOwnedId);
    hasChangeAnyValue = false;
    cancelUnClaim();
    cryo_appOpenLoading();
    hideControllerBlock();
    getObj("inpAction").value = "UPDATE";
    getObj("inpCodFlowResult").value = "4";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    submitForm();
}

function confirmNotConclude() {
    var validateResult, validateLogHoursResult, validateAdHocResult;

    validateResult = validate();
    checkListResult = verifyCheckList();
    validateLogHoursResult = validateLogHours();
    validateAdHocResult = true;

    if (validateResult && validateLogHoursResult && validateAdHocResult && checkListResult) {
        signPostResult = true;

        // nao marcou para assinar tarefa
        finishNotConclude();
    }

    return (validateResult && signPostResult && validateLogHoursResult && validateAdHocResult && checkListResult);
}

function submitForm() {
    let timeout = 0;
    const modal = getObj("modal-processing-task");

    if (modal) {
        new BSN.Modal(modal, { backdrop: "static", keyboard: false }).show();
        timeout = 1100;
    }

    setTimeout(function () {
        const form = getObj("frm");
        form.submit();
    }, timeout);
}

function addMessageLineAjax(message, nome, bDel, bPublic) {
    var url = "";
    var data = "";
    var $action = $("#inpAction");
    var codflowexecutetask = $("#inpCodFlowExecuteTask").val();
    var codflowexecute = $("#inpCodFlowExecute").val();
    var strequestermessage = (bPublic ? "S" : "N");
    var messageusersmentioned = $("#inpMessageCodUsersMentioned").val();
    var coduserspending = $('input[name="inpCodUsersPending"]').map(function () { return this.value; }).get().join(',');

    //report or task
    if ($action.length == 0 || ($action.val() == "EDIT" || $action.val() == "SAVE")) {
        url = URL_ROOT + "workflow/wfflow_execute_message_xml.aspx";
        data = {
            "inpCodFlowExecuteTask": codflowexecutetask,
            "inpCodFlowExecute": codflowexecute,
            "inpDsMessage": message,
            "inpStRequesterMessage": strequestermessage,
            "inpMessageCodUsersMentioned": messageusersmentioned,
            "inpCodUsersPending": coduserspending,
            "inpNotifyOtherUsers": ($action.length === 0 ? 1 : 0)
        };

        $(".message-ajax-loading").show();

        $.post(url, data, function (data) {
            var codmessage = data.getElementsByTagName('rows').item(0).firstChild.data;
            addMessageLine(message, nome, bDel, bPublic, codmessage);
        }).done(function () {
            if (messageusersmentioned != "") {
                $(".notify-users-success").fadeIn(400).delay(2000).fadeOut(400);
            }
            if (coduserspending != "") {
                $(".notify-pending-users-success").fadeIn(400).delay(2000).fadeOut(400);
            }
            $("#inpDsMessage").val('');
            $("#inpMessageCodUsersMentioned").val('');
            $(".message-ajax-loading").hide();
        }).fail(function (xhr, textStatus, errorThrown) {
            $(".message-ajax-loading").hide();
            if (xhr.responseText)
                alert(xhr.responseText);
        });
        //new process
    } else if ($action.val() == "NEW") {
        addMessageLine(message, nome, bDel, bPublic);
        $("#inpDsMessage").val('');
        $("#inpMessageCodUsersMentioned").val('');
        $(".message-ajax-loading").hide();
    }
}

function htmlEncode(value) {
    var result = filterXSS(value);
    return result;
}

function addMessageLine(message, name, bDel, bPublic, codmessage) {
    message = htmlEncode(message);
    message = message.replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll(/\n/gi, '<br>');
    message = message.replace(/(@[\S]*)/g, '<b>$1</b>');
    message = unescape(message);
    var bNotEdit = (document.getElementById("inpAction") == null || document.getElementById("inpAction").value != "EDIT");
    var $tbody = $("#tblMessage tbody");
    var row = "";
    var date = `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
    row += "<tr>";
    if (!clientIsMobile) {
        row += "<td class=\"lock\"><input type=\"hidden\" name=\"inpStRequesterMessage\" id=\"inpStRequesterMessage\" value=\"" + (bPublic ? "S" : "N") + "\">" + (!bPublic ? "<img src=\"" + URL_ROOT + "common/images/v3/locker.png\" border=\"0\" alt=\"" + mlLblLockedMessage + "\">" : "") + "</td>";
        row += "<td class=\"date\">" + date + "</td>";
        row += "<td class=\"actor text-right\">" + name + "</td>";
    } else {
        row += "<td class=\"actor-photo text-right\"><input type=\"hidden\" name=\"inpStRequesterMessage\" id=\"inpStRequesterMessage\" value=\"S\"></td>";
    }
    row += "<td class=\"message\">";
    if (bNotEdit) {
        row += "    <input type=\"hidden\" name=\"inpDsMessageBody\" id=\"inpDsMessageBody\" value='" + replaceAll(message, "'", "\"") + "'>";
    }
    row += "    <div class=\"comment-text\">" + message + "</div>";
    if (clientIsMobile) {
        row += "    <div class=\"message-actorname\">" + name + "</div>";
        row += "    <div class=\"message-date\">" + date + "</div>";
    }
    row += "</td>";
    if (!clientIsMobile) {
        row += "<td class=\"task\"></td>";
        row += "<td class=\"process\"></td>";
    }
    let delMessageEnable = "<a href=\"javascript:void(0)\" onclick=\"javascript:delMessageWrapper(this," + codmessage + ")\"><i class=\"icon-remove\"></i></a>";
    let delMessageDisabled = "&nbsp;"
    row += "<td class=\"del\">" + (bDel ? delMessageEnable : delMessageDisabled) + "</td>";
    row += "</tr>";
    $tbody.find("tr:last").before(row);
}

function editMessage(em) {
    $("#inpDsMessage").val($(em).html());
    return delMessage(em, null);
}

function delMessageWrapper(a, codmessage) {
    if (confirm(ml_LblDeleteRecord)) {
        return delMessage(a, codmessage);
    } else {
        return false;
    }
}

function delMessage(a, codMessage) {
    var url = "";
    var $action = $("#inpAction");
    if ($action.length == 0 || $action.val() == "EDIT") {
        //se tiver inpCodFlowExecuteTask, é execução de tarefa 1.0, se tiver inpCodFlowExecuteTask_ToAddMessage, é relatório
        var codFlowExecuteTask =
            document.getElementById("inpCodFlowExecuteTask") !== null
                ? document.getElementById("inpCodFlowExecuteTask").value
                : document.getElementById("inpCodFlowExecuteTask_ToAddMessage") !== null
                    ? document.getElementById("inpCodFlowExecuteTask_ToAddMessage").value
                    : 0;

        url = URL_ROOT + "workflow/wfFlow_Execute_Message_Xml.aspx?";
        url += "&inpCodMessage=" + codMessage;
        url += "&inpCodFlowExecute=" + document.getElementById("inpCodFlowExecute").value;
        url += "&inpCodFlowExecuteTask=" + codFlowExecuteTask;
        url += "&inpCodFlowExecuteMaster=" + document.getElementById("inpCodFlowExecuteMaster").value;

        $.post(url, function (data) {
        }).done(function () {
            getObj("tblMessage").deleteRow(a.parentNode.parentNode.rowIndex); //alterado por rafael - 12/06/2008
        });
    } else {
        getObj("tblMessage").deleteRow(a.parentNode.parentNode.rowIndex); //alterado por rafael - 12/06/2008
    }

    return true;
}

function HasInput(obj) {
    var i = 0;
    var o;
    var ret = false;
    while (obj.childNodes[i] != null) {
        o = obj.childNodes[i];
        if (o.type == "text" ||
            o.type == "textarea" ||
            o.type == "password" ||
            o.type == "select" ||
            o.type == "select-one") {
            ret = true;
        } else {
            ret = HasInput(o);
        }
        i++;
        if (ret) {
            return ret;
        }
    }
    return ret;
}

function HasDiv(obj) {
    var i = 0;
    var o;
    var ret = false;

    while (obj.childNodes[i] != null) {
        o = obj.childNodes[i];
        if (o.tagName != null && o.tagName.toLowerCase() == "div") {
            ret = true;
        } else {
            ret = HasDiv(o);
        }
        i++;
        if (ret) {
            return ret;
        }
    }
    return ret;
}

function MultipleTable() {
    var aTables = [];
    aTables = document.getElementsByTagName("TABLE");
    for (var i = 0; i < aTables.length; i++) {
        if (cryo_GetObjectPropertyValue(aTables[i], "mult") != null) { // alterado por leonardo - 16/04/2008
            if (cryo_GetObjectPropertyValue(aTables[i], "mult") == "S") { // alterado por leonardo - 16/04/2008
                if (HasInput(aTables[i])) {
                    var o = aTables[i];
                    for (var k = 0; k < o.rows.length; k++) {
                        // alterado por leonardo - 16/04/2008
                        removeWhiteSpaces(o);

                        var c = o.rows[k].insertCell(0);
                        c.style.verticalAlign = "top";
                        if (k == 0) {
                            if (GRID_SHOW_INSERT) {
                                // alterado por leonardo - 16/04/2008
                                c.innerHTML = "<button type=\"button\" onclick=\"InsertNewRow(this,true)\" id=\"BtnInsertNewRow\" class=\"btn btn-mini btn-sm btn-insert-mv\">" + mlBtnInsert + "</button>";
                            } else {
                                c.innerHTML = "&nbsp;";
                            }
                        } else {
                            if (GRID_SHOW_DELETE) {
                                // alterado por leonardo - 16/04/2008
                                c.innerHTML = "<button type=\"button\" onclick=\"DeleteRow(this)\" class=\"btn btn-mini btn-sm  btn-delete-mv\">" + mlBtnDelete + "</button>";
                            } else {
                                c.innerHTML = "&nbsp;";
                            }
                        }
                        c.style.width = "30px";
                    }
                } else if (!HasDiv(aTables[i])) {
                    aTables[i].style.display = "none";
                }
            }
        }
    }
}

// Ao inserir uma nova linha na tabela multivalorada é chamado o método clone
// esse método irá clonar toda a linha, incluindo os valores preenchidos
// para isso utilizamos o método abaixo, para limpar os divs e inputs das novas linhas
// inseridas nas tabelas multivaloradas
function CleanUpInput(obj, screen) {
    var i = 0;
    var o;
    removeWhiteSpaces(obj);
    while (obj.childNodes[i] != null) {
        o = obj.childNodes[i];
        if (o.tagName == "INPUT" ||
            o.tagName == "TEXTAREA" ||
            o.tagName == "PASSWORD" ||
            o.tagName == "HIDDEN" ||
            o.tagName == "SELECT" ||
            o.tagName == "SELECT-ONE")
            o.value = "";
        else if (o.tagName == "DIV") {
            if (o.id.substring(0, 3) == "div") {
                o.innerHTML = "";
            }
        } else if (o.tagName == "IMG" && screen) {
            if (cryo_GetOuterHTML(o).indexOf("sign_small") > -1) {
                o.style.display = "none";
            }
        } else if (o.tagName === "BUTTON") {
            if (o.id.substring(0, 9).toUpperCase() === "BTNUPLOAD") {
                o.style.display = "";
            }
        }

        if ((o.tagName == "SELECT" || o.tagName == "SELECT-ONE") && o.getAttribute("data-dependencies"))
            o.options.length = 0;

        CleanUpInput(o, screen);
        i++;
    }
}

function IsMultiple(btn) {
    var tbl = btn;
    var found = false;
    while (!found && tbl != null) {
        // alterado por leonardo - 16/04/2008
        tbl = tbl.parentNode;
        while (tbl != null && tbl.tagName != "TABLE") {
            // alterado por leonardo - 16/04/2008
            tbl = tbl.parentNode;
        }
        if (tbl != null) {
            if (cryo_GetObjectPropertyValue(tbl, "mult") != null) { // alterado por leonardo - 16/04/2008
                if (cryo_GetObjectPropertyValue(tbl, "mult") == "S") { // alterado por leonardo - 16/04/2008
                    found = true;
                }
            }
        }
    }
    if (found) {
        return true;
    } else {
        return false;
    }
}

function InsertNewRow(btn, screen, objTable, value) {
    var tbl = btn;
    var found = false;
    var oldRow;

    if (screen == null) {
        screen = false;
    }

    while (!found && tbl != null) {
        tbl = tbl.parentNode; // alterado por leonardo - 16/04/2008
        while (tbl != null && tbl.tagName != "TABLE") {
            tbl = tbl.parentNode; // alterado por leonardo - 16/04/2008
        }
        if (tbl != null) {
            if (cryo_GetObjectPropertyValue(tbl, "mult") != null) { // alterado por leonardo - 16/04/2008
                if (cryo_GetObjectPropertyValue(tbl, "mult") == "S") { // alterado por leonardo - 16/04/2008
                    found = true;
                }
            }
        }
    }
    if (found || objTable) {
        if (found == false) {
            tbl = objTable;
        }

        removeWhiteSpaces(tbl);
        oldRow = tbl.rows[1];
        var newRow = oldRow.cloneNode(true);
        tbl.getElementsByTagName("tbody")[0].appendChild(newRow);

        if (screen == true) {
            // chamar esse método somente se os campos estiverem habilitados
            CleanUpInput(newRow, screen);

            cryo_processSelect();
            cryo_processSubSelect(newRow, value);
            cryo_processSuggestionsTable(newRow);
            cryo_processSearchAndFill();
        }

        // must apply masks to the form field on the new line
        applyMasksToFormFields(newRow);
    }

    if (typeof formulaObj !== 'undefined' && formulaObj) {
        formulaObj.init();
    }

    return oldRow;
}

function DeleteRow(btn) {
    var tbl = btn;
    var found = false;
    while (!found && tbl != null) {
        tbl = tbl.parentNode;
        while (tbl != null && tbl.tagName != "TABLE") {
            tbl = tbl.parentNode;
        }
        if (tbl != null) {
            if (cryo_GetObjectPropertyValue(tbl, "mult") != null) {
                if (cryo_GetObjectPropertyValue(tbl, "mult") == "S") {
                    found = true;
                }
            }
        }
    }
    if (found) {
        if (tbl.rows.length > 2) {
            tr = btn;
            while (tr != null && tr.tagName != "TR") {
                tr = tr.parentNode;
            }
            if (tr != null) {
                var nextTr = tr.nextElementSibling;
                if (nextTr?.querySelector("[id^=divDocLoad_]"))
                    tbl.deleteRow(nextTr.rowIndex);

                tbl.deleteRow(tr.rowIndex);
                if (formulaObj) {
                    formulaObj.triggerBlurFields();
                }
            }
        } else {
            alert(mlMsgLineDeletionNotAllowed);
        }
    }
}

function FieldLength(n) {
    var count = 0;
    //var e = getObj("frm").elements;
    var e = document.forms[0].elements;
    for (var i = 0; i < e.length; i++) {
        if (e[i].name == n) {
            count++;
        }
    }
    return count;
}

var retFields = "";    //alterado nome em 29.04.07 por rafael

var nrx;

//alterado rafael 11/11/2008
var noFill = null;

function delFileWrapper(a, codfile) {
    if (confirm(ml_LblDeleteRecord)) {
        delFile(a, codfile)
    } else {
        return false;
    }
}

function isFirstColumn(arr) {
    var counts = [...new Set(arr)];
    return counts.length <= 2
}

function FillValue(n, v, originalValue) {
    var obj, o, q;
    if (getObject("inp" + n) != null) {
        obj = getObject("inp" + n);

        if (obj.length != undefined && obj.length != 0 && obj.type != "select-one") {
            obj = getObject("inp" + n)[0];
        }

        try {
            if (obj != null && obj.type == undefined) {
                return;
            }
        } catch (e) { }

        if (obj.type == "checkbox" || obj.type == "radio") {
            obj = getObject("inp" + n);

            if (obj.length != undefined) {
                for (var j = 0; j < obj.length; j++) {
                    if (obj[j].value == v) {
                        obj[j].checked = true;
                    }
                }
            } else {
                if (obj.value == v) {
                    obj.checked = true;
                }
            }
        }
        else if (obj.type == "text" ||
            obj.type == "textarea" ||
            obj.type == "password" ||
            obj.type == "hidden" ||
            obj.type == "select" ||
            obj.type == "select-one" ||
            obj.type == "select-multiple") {
            //---------------------------------------------
            q = retFields.split(n).length;

            if (q > 1) {
                if (FieldLength("inp" + n) > q - 1) {
                    obj = getObject("inp" + n);
                    o = obj[q - 1];

                    //P800 #38609 - processar campos em linhas que não sejam a primeira em tabela mv com mais de uma linha inicial
                    if (isFirstColumn(retFields.split(';'))) {
                        var tr = o.closest("tr");
                        cryo_processSubSelect(tr, v);
                        cryo_processSuggestionsTable(tr);
                    }
                } else {
                    if (IsMultiple(obj)) {
                        var nr = InsertNewRow(obj, true, null, v);

                        obj = getObject("inp" + n);
                        o = obj[q - 1];
                    } else {
                        o = obj;
                    }
                }
            } else {
                o = obj;
            }

            //Multivalorado com campos de selecao dependentes, ex: coluna estado e cidade
            if (o.type == "select-one" && o.getAttribute("data-dependencies") && IsMultiple(o) && o.options.length == 0) {
                var tr = $(o).closest("tr");
                var $destiny = o;
                var deps = $destiny.getAttribute("data-dependencies").split(",");

                deps.forEach(function (dep) {
                    var $origin = tr.find("[xname=inp" + dep + "]");
                    $($origin).trigger("change.processDependencies." + $destiny.getAttribute("xname"), { value: v });
                });
            }
            else {
                o.value = v;
            }

            //alterado rafael 11/11/2008
            if (noFill != o && cryo_GetObjectPropertyValue(o, "xtype") == "FORMS") {
                selectMultipleForm(v, o, false);
            }
        }

        fillZeevFormFieldsArray(o, obj, n, v, q)
        
    }

    if (getObject("div" + n) != null) {
        if (window.attachEvent) {
            obj = getObject("div" + n);
        } else {
            obj = cryo_GetElementByAttribute("id", "div" + n);
        }

        if (obj.length != undefined && obj.length != 0 && obj.type != "select-one") {
            obj = cryo_GetElementByAttribute("id", "div" + n)[0];
        }
        //---------------------------------------------
        q = retFields.split(n).length;
        if (q > 1) {
            if (cryo_GetElementByAttribute("id", "div" + n).length > q - 1) {
                // inicio bloco alterado em 20/01/2009
                if (window.attachEvent) {
                    if (obj.length) {
                        o = obj[q - 1];
                    } else {
                        o = obj;
                    }
                } else {
                    obj = cryo_GetElementByAttribute("id", "div" + n);
                    // inicio bloco alterado em 19/02/2010
                    if (obj.length) {
                        o = obj[q - 1]; // BUG 48 - Leonardo - alterado em 16/4/2009
                    } else {
                        o = obj;
                    }
                }
                // fim bloco alterado em 19/02/2010
                // fim bloco alterado em 20/01/2009
            } else {
                if (IsMultiple(obj)) {
                    nrx = InsertNewRow(obj);
                    obj = document.querySelectorAll("div[id$='div" + n + "']");
                    if (obj.length != undefined) {
                        o = obj[q - 1];
                    } else {
                        o = obj;
                    }
                    //obj = getObject("div" + n);
                    //if (window.attachEvent) {
                    //o = obj[q - 1];
                    //} else {
                    //    o = obj;
                    //}
                } else {
                    if (obj.length != undefined) {
                        o = obj[q - 1];
                    } else {
                        o = obj;
                    }
                }
            }
        } else {
            if (obj.length != undefined) {
                o = obj[0];
            } else {
                o = obj;
            }
        }

        //---------------------------------------------

        var regexp = new RegExp("((f|ht)tps?://[^ \n]*)", "g");
        var regexp2 = new RegExp("<a[^>]*", "g");
        if (regexp.test(v) && !regexp2.test(v)) {
            v = v.replace(regexp, "<a href=\"$1\" target=\"_blank\">$1</a>");

            if (cryo_GetObjectPropertyValue(o, "xtype") == "TEXTAREA") {
                // 14/07/2009 - Leonardo - Quando é textarea deve fazer replace de Quebra de Linha por <br> para exibição
                o.innerHTML = v.replace(/\n/gi, "<br>");
            } else {
                o.innerHTML = v;
            }
        } else {
            if (o != null) {
                if (o.innerHTML != "" && (
                    // leonardo 16/04/2008
                    //o.xtype=="RADIO" ||
                    //o.xtype=="CHECKBOX")) {
                    // alterado para funcionar no firefox
                    cryo_GetObjectPropertyValue(o, "xtype") == "RADIO" ||
                    cryo_GetObjectPropertyValue(o, "xtype") == "CHECKBOX")) {
                    // não adiciona valores vazios a lista de valores readonly

                    // inicio bloco alterado em 21/11/2008
                    if (v != "" && !cryo_GetObjectPropertyValue(o, "customValue")) {
                        o.innerHTML += ", " + v;
                    } else if (originalValue != "" && typeof (originalValue) != "undefined" && cryo_GetObjectPropertyValue(o, "customValue")) {
                        o.innerHTML += ", " + originalValue;
                    }
                    // fim bloco alterado em 21/11/2008
                }
                else if (cryo_GetObjectPropertyValue(o, "xtype") == "PASSWORD") {
                    o.innerHTML = "*******";
                } else {
                    // inicio bloco alterado em 21/11/2008
                    // BUG 80 - 09/07/2009 - Evitar que o campo seja preenchido com valor vazio
                    // Leonardo - 16/04/2010 - Evitar que o campo fique preenchido com valor "undefined"
                    if (cryo_GetObjectPropertyValue(o, "customValue") && originalValue != "" && typeof (originalValue) != "undefined") {
                        o.innerHTML = originalValue;
                    } else {
                        if (cryo_GetObjectPropertyValue(o, "xtype") == "TEXTAREA") {
                            // 14/07/2009 - Leonardo - Quando é textarea deve fazer replace de Quebra de Linha por <br> para exibição
                            o.innerHTML = htmlEncode(v).replace(/\n/gi, "<br>");
                        } else {
                            o.innerHTML = htmlEncode(v);
                        }
                    }
                    // fim bloco alterado em 21/11/2008

                    //alterado rafael 11/11/2008
                    if (noFill != o && cryo_GetObjectPropertyValue(o, "xtype") == "FORMS") {
                        selectMultipleForm(v, o, true);
                    }
                }
            }
        }
    }
    retFields += n + ";"
}

function fillZeevFormFieldsArray(o, obj, n, v, q) {
    let reference;
    let type;
    if (o) {
        reference = o;
        type = o?.type;
    }
    else if (NodeList.prototype.isPrototypeOf(obj)) {
        reference = obj[0];
        type = obj[0]?.type;
    }
    else {
        reference = obj;
        type = obj?.type;
    }

    if ((reference.attributes['data-fieldformat']?.value != 'CHECKBOX' &&
        reference.attributes['data-fieldformat']?.value) ||
        v) {
        ZEEV_FORM_FIELDS.push({
            field: n,
            value: v,
            ref: reference,
            type: type,
            order: q
        });
    }

}

function fillSelect(element, optionsArray, index) {
    if (!element || typeof (element) != 'object') {
        console.error(`[ERRO] Erro ao utilizar a função, parâmetro element deve receber uma referência para um elemento no DOM.`);
        return;
    }

    element.innerHTML = '<option value="">Selecione</option>';

    optionsArray.forEach((option) => {
        var opt = document.createElement("option");
        opt.value = option.value;
        opt.text = option.text;
        element.appendChild(opt)
    })

    var elementId = element.attributes['name']?.value.replace('inp', '');
    let elementValue = ZEEV_FORM_FIELDS.find(x => x.field == elementId && x.order == index)?.value;
    element.value = elementValue;

    return element;
}

/**
 * Método migrado da versão em C# para JavaScript puro.
 *
 * Objetivo:
 * - Garantir a mesma regra de negócio de renderização de links de preview e download de arquivos
 *   (comportamento diferenciado para mobile, IE antigo e navegadores modernos).
 * - Substituir a renderização de HTML pronto via string/innerHTML por criação de elementos DOM reais,
 *   aumentando a segurança (evita injeção de HTML e XSS).
 * - Facilitar manutenção futura, mantendo o código mais explícito e próximo das regras originais.
 *
 * Observação:
 * Apesar de equivalente à versão anterior em C#, o código foi mantido verboso de propósito,
 * para preservar clareza na leitura das diferentes condições de negócio.
 */
function fillValueFile(encryptedParameters, filename, uniqueFileName, downloadLabel, clientIsMobile, isOldInternetExplorer, codField) {    
    let container = Array.from(document.querySelectorAll(`div[id=div${codField}]`))
        .find(el => el.innerHTML.includes(uniqueFileName));

    if (!container) return;
    container.innerHTML = "";

    const urlToPreview = `${URL_ROOT}document/preview/${filename}?c=${encryptedParameters}`;
    const urlToDownload = `${URL_ROOT}document/download/${filename}?c=${encryptedParameters}`;

    const createLink = ({ href, title, text, target, onClick, attrs = {} }) => {
        let a = document.createElement("a");
        if (href) a.href = href;
        if (title) a.title = title;
        if (target) a.target = target;
        if (text) a.textContent = text;
        if (onClick) a.addEventListener("click", onClick);
        Object.entries(attrs).forEach(([k, v]) => a.setAttribute(k, v));
        return a;
    };

    const createDownloadIconLink = (href, title, onClick) => {
        let link = createLink({ href, title, onClick });
        let icon = document.createElement("i");
        icon.className = "icon-download";
        link.appendChild(icon);
        return link;
    };

    if (clientIsMobile) {
        container.appendChild(createLink({ href: urlToPreview, target: "_blank", title: filename, text: filename }));
        container.appendChild(document.createTextNode(" "));
        container.appendChild(createDownloadIconLink("javascript:void(0);", downloadLabel, () => window.open(urlToDownload, "blank")));

    } else if (isOldInternetExplorer) {
        let link = createDownloadIconLink(urlToDownload, downloadLabel);
        link.insertBefore(document.createTextNode(filename), link.firstChild);
        container.appendChild(link);

    } else {
        container.appendChild(createLink({ href: urlToPreview, target: "_blank", title: filename, text: filename, attrs: { "data-colorbox": "true" } }));
        container.appendChild(document.createTextNode(" "));
        container.appendChild(createDownloadIconLink(urlToDownload, downloadLabel));
    }
}


function fillValueFileView(dsFieldName, fileNameExtension, encryptedParameters, codFlowExecute, codField, signedFile, digitalSignType, parametersSignatureDetails, hasElectronicSignatures, codOrder) {
    let elementFile = cryo_GetElementByAttribute('xid', 'div' + dsFieldName);

    if (!elementFile) return;

    if (Array.isArray(elementFile))
        elementFile = elementFile[codOrder - 1]

    elementFile.style.display = 'none';

    let inputFile = cryo_GetElementByXname('inp' + dsFieldName);
    if (!inputFile) {
        //se não encontra o input do arquivo, procura a div de somente leitura...
        inputFile = cryo_GetElementByAttribute('xid', 'div' + dsFieldName);
    }

    if (Array.isArray(inputFile))
        inputFile = inputFile[codOrder - 1]

    const btnDownload = document.createElement('button');
    btnDownload.id = 'btnDownload_' + dsFieldName;
    btnDownload.className = 'btn btn-xs btn-secondary';
    btnDownload.style.marginRight = '1em';
    btnDownload.innerText = 'Download';
    btnDownload.onclick = function () {
        event.preventDefault();
        location.href = URL_ROOT + 'document/download/' + fileNameExtension + '?c=' + encryptedParameters;
    };

    inputFile.after(btnDownload);

    const divDocLoadId = `divDocLoad_${dsFieldName}`;
    const row = elementFile.closest("tr");

    var tableCols = 2;
    if (elementFile.closest('table')?.attributes['mult']?.value)
        tableCols = elementFile.closest('tbody tr').querySelectorAll('td').length

    if (row) {
        var docViewTr = row.nextSibling;
        if (!docViewTr?.attributes || docViewTr?.attributes['Id']?.value != 'docViewTr') {
            row.insertAdjacentHTML("afterEnd",
                `<tr id="docViewTr">
                    <td colspan="${tableCols}" id="docViewTd">                        
                    </td>
                </tr>`);
        }

        docViewTd = row.nextSibling.querySelector("#docViewTd");
        if (!docViewTd.querySelector(`#${divDocLoadId}`)) {
            docViewTd.insertAdjacentHTML("beforeEnd",
                `<div id="${divDocLoadId}" class="text-center" style="display: block">
                            ${mlMsgLoading}
                            <img src="${URL_ROOT}common/images/v3/loading_ajax.gif"/>
                        </div>
                        <div id="divDocContent_${dsFieldName}" class="d-block" style="display: block"/><br>`);
        }
    }
    else {
        let button = document.getElementById("btnUpload" + dsFieldName);

        if (!button) button = btnDownload;

        button.insertAdjacentHTML("afterEnd",
            `<div style="margin: 1rem">
                <div id="${divDocLoadId}" class="text-center">
                    ${mlMsgLoading}
                    <img src="${URL_ROOT}common/images/v3/loading_ajax.gif"/>
                </div>
                <div id="divDocContent_${dsFieldName}"/>
            </div>`);
    }

    const divDocLoad = cryo_GetElementByAttribute('id', divDocLoadId);

    getPreviewEmbed(fileNameExtension, encryptedParameters, dsFieldName, divDocLoad, codOrder);

    if (digitalSignType !== 'FI' && hasElectronicSignatures === 'True') {
        createDownloadElectronicSignatures(dsFieldName, btnDownload, codFlowExecute, codField, fileNameExtension, encryptedParameters);
    }

    if (signedFile === 'True' && hasElectronicSignatures !== 'True') {
        createSignatureInfo(dsFieldName, btnDownload, parametersSignatureDetails);
    }
}

function createSignatureInfo(dsFieldName, btndownload, parametersSignatureDetails) {
    var btnSignatureInfo = document.createElement('button');
    btnSignatureInfo.id = 'btnSignatureInfo_' + dsFieldName;
    btnSignatureInfo.className = 'btn btn-secondary';
    btnSignatureInfo.style.marginRight = '1em';
    btnSignatureInfo.innerText = mLblDigitalSignatureInfo;
    btndownload.parentNode.insertBefore(btnSignatureInfo, btndownload.nextSibling);
    btnSignatureInfo.onclick = function (e) {
        e.preventDefault();
        if (document.getElementById("inpDsExecutionMode") == null || getExecutionMode() === '1.0')
            $.colorbox({ href: URL_ROOT + 'WorkFlow/wfDigitalSignatureFileDetails.aspx?c=' + parametersSignatureDetails, width: '75 %' });
        else
            bsml.modalOpen(URL_ROOT + 'WorkFlow/wfDigitalSignatureFileDetails.v2.aspx?c=' + parametersSignatureDetails, 3);
    };
}

function createDownloadElectronicSignatures(dsFieldName, btnDownload, codFlowExecute, codField, fileNameExtension, encryptedParameters) {
    var btnDownloadSigned = document.createElement('button');
    btnDownloadSigned.id = 'btnDownloadSigned_' + dsFieldName;
    btnDownloadSigned.className = 'btn';
    btnDownloadSigned.style.marginRight = '1em';
    btnDownloadSigned.innerText = mLblDownloadFileElectronic;
    btnDownload.parentNode.insertBefore(btnDownloadSigned, btnDownload.nextSibling);
    btnDownloadSigned.onclick = function (e) {
        e.preventDefault();

        var request = new XMLHttpRequest();
        let url = `${window.appvars.services.electronicsignature.verifyhash}?codFlowExecute=${codFlowExecute}&codField=${codField}`
        request.open('GET', url, true);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");

        var afToken = document.querySelector("input[name=__RequestVerificationToken]");
        if (afToken)
            request.setRequestHeader("X-SML-AntiForgeryToken", afToken.value);

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                var data = JSON.parse(request.responseText);

                if (data.success)
                    location.href = URL_ROOT + 'document/download_signed/' + fileNameExtension + '?c=' + encryptedParameters;
                else
                    alert(mMsgAlteredDocument);
            } else {
                alert(mMsgAlteredDocument);
            }
        };

        request.onerror = function () {
            alert(mMsgAlteredDocument);
        };
        request.send();
    };
}

function getPreviewEmbed(fileNameExtension, encryptedParameters, dsFieldName, divDocLoad, codOrder) {
    var httpGet = new XMLHttpRequest();
    httpGet.open("GET", URL_ROOT + 'document/preview_embed/' + fileNameExtension + '?c=' + encryptedParameters, true);
    httpGet.onload = function (data) {
        if (httpGet.status >= 200 && httpGet.status < 400 && !httpGet.responseURL.includes('inpLostSession=1')) {
            var divDocContent = cryo_GetElementByAttribute('id', 'divDocContent_' + dsFieldName);
            if (Array.isArray(divDocContent))
                divDocContent = divDocContent[codOrder - 1]

            divDocContent.insertAdjacentHTML('afterbegin', httpGet.responseText);

            const docContentFile = divDocContent.querySelector('#divDocContent_' + dsFieldName + ' #divPdfJs script');
            if (docContentFile) eval(divDocContent.querySelector('#divDocContent_' + dsFieldName + ' #divPdfJs script').innerHTML);

            if (Array.isArray(divDocLoad))
                divDocLoad = divDocLoad[codOrder - 1];
            
            divDocLoad.style.display = 'none';

        }
    };
    httpGet.send();
}

function delFile(a, codfile) {
    var tr = a.parentNode.parentNode;
    var table = tr.parentNode.parentNode;
    table.deleteRow(tr.rowIndex)
    if (codfile != null) {
        getObj("inpCodFileDelete").value += codfile + ",";
    }
    captureModule.capture.load();
}

function delFileFormField(formFieldName, btn) {
    var index = -1;

    if (btn && isInsideMultipleValueTable(btn)) {
        index = getParentByFilter(btn, function (elTR) {
            return elTR.nodeName.toLowerCase() === "tr";
        }).rowIndex - 1;
        linesWithDocumentViewer = [...btn.closest('tbody').querySelectorAll('tr:not(.header)')].slice(0, tr.rowIndex).filter((i) => i.querySelector('div[id^=divDocContent_]')).length
        index = index - linesWithDocumentViewer;
    }

    var div = cryo_GetElementByAttribute("xid", "div" + formFieldName);
    var input = cryo_GetElementByXname("inp" + formFieldName);

    if (index > -1 && div.length && input.length) {
        div = div[index];
        input = input[index];
    }

    div.innerHTML = "";
    input.value = "";

    var btnUpload = getSiblings(input, function (elBtn) {
        return elBtn.nodeName.toLowerCase() === "button" && elBtn.id === "btnUpload" + formFieldName;
    });

    if (btnUpload && btnUpload.length > 0) {
        btnUpload = btnUpload[0];
    }
    else {
        btnUpload = document.getElementById("btnUpload" + formFieldName)
    }

    btnUpload.style.display = "";
}

function delFileDocument(formFieldName) {
    var div = cryo_GetElementByAttribute("xid", "div" + formFieldName);
    var input = cryo_GetElementByXname("inp" + formFieldName);

    div.innerHTML = "";
    input.value = "";
    document.getElementById("btnUpload" + formFieldName).style.display = "";

    $('#ContainerDocument').remove();

    var trDoc = $('div[xid=div' + formFieldName + ']').parents('tr:first');
    trDoc.show();

    var codGroup = trDoc.attr('codgroup');

    if (trDoc.siblings('[codgroup=' + codGroup + ']').addBack().filter(function () { { return $(this).css('display') !== 'none'; } }).length === 0) {
        $('#group' + codGroup).parents('tr:first').hide();
    }
    else {
        $('#group' + codGroup).parents('tr:first').show();
    }
}

function addFileLine(nome, nomeArquivo, path, querystring, resumo, data, sign, bDel, bPublic, tipoArquivo) {
    bPublic = (bPublic == null ? true : bPublic);

    var $table = $("#tblNewFile");
    $table.show();
    var $tbody = $("#tblNewFile tbody");

    var novoResumo;
    resumo = resumo.replace(/\n/gi, "<br>");
    novoResumo = replaceAll(resumo, ",", "!@!");
    novoResumo = replaceAll(novoResumo, ";", "$@$");
    novoResumo = replaceAll(novoResumo, "\"", "&quot;");
    var baseUrl = location.origin + URL_ROOT + "document/preview/uploadled-file";
    var row = "<tr>";
    row += "<td class=\"lock\"><input type=\"hidden\" id=\"inpStRequesterFile\" value=\"" + (bPublic ? "S" : "N") + "\">" + (!bPublic ? "<img src=\"" + URL_ROOT + "common/images/v3/locker.png\" border=\"0\" alt=\"" + mlLblLockedFile + "\" >" : "") + "</td>";
    row += "<td class=\"fileicon\">&nbsp;</td>";
    row += "<td class=\"filename\"><a href=\"" + path + "\" querystring=\"" + baseUrl + querystring + "\" data-colorbox=\"true\" target=\"_blank\" title=\"" + nomeArquivo + "\">" + nomeArquivo + "</a><div class=\"muted\">" + resumo + "</div></td>";
    row += "<td class=\"del\"><input type=\"hidden\" name=\"inpDsFileName\" value=\"" + nomeArquivo + ";" + path + ";" + novoResumo + ";" + sign + ";" + (bPublic ? "S" : "N") + ";" + tipoArquivo + "\">" + (bDel ? "<a href=\"javascript:void(0)\" title=\"excluir\" class=\"delFile\" onclick=\"javascript:delFileWrapper(this)\"><i class=\"icon-remove\"></i></a>" : "") + "</td>";
    row += "</tr>";
    $tbody.append(row);
}

function addFileFormField(nome, nomeArquivo, path, resumo, data, sign, bDel, bPublic, formFieldName, viewerCrypt, rowIndex) {
    var divInnerHtml = "";
    var div = cryo_GetElementByAttribute("xid", "div" + formFieldName);
    var input = cryo_GetElementByXname("inp" + formFieldName);

    if (rowIndex > -1 && div.length && input.length) {
        div = div[rowIndex];
        input = input[rowIndex];
    }

    if (div && input) {
        let url = `${window.appvars.baseurl}/document/preview/${nomeArquivo}${viewerCrypt}`;

        if (!viewerCrypt || viewerCrypt.indexOf("preview_embed") < 0) {
            divInnerHtml = "<a href=\"" + url + "\" target=\"_blank\">" + nomeArquivo + "</a>";
            if (bDel) {
                divInnerHtml += "&nbsp;<a class=\"btn btn-mini btn-danger\" href=\"javascript:void(0)\" title=\"" + mlLblDelete + "\" onclick=\"javascript:delFileFormField('" + formFieldName + "', this)\"><i class=\"icon-remove icon-white\"></i></a>";
            }
            input.value = path;

            // esconder o botão de upload
            var btnUpload = getSiblings(input, function (elBtn) {
                return elBtn.nodeName.toLowerCase() === "button" && elBtn.id === "btnUpload" + formFieldName;
            });

            if (btnUpload && btnUpload.length > 0) {
                btnUpload = btnUpload[0];
            }
            else {
                btnUpload = document.getElementById("btnUpload" + formFieldName)
            }

            btnUpload.style.display = "none";

            div.innerHTML = divInnerHtml;
        }
        else {
            input.value = path;
            div.style.display = "none";
            const isMultiTable = input.closest('table')?.attributes['mult']?.value;

            let divDocContentId = "#divDocContent_" + formFieldName;
            let divDocLoadId = "#divDocLoad_" + formFieldName;
            let btnDownloadId = "#btnDownload_" + formFieldName;
            let divDocContent;
            let divDocLoad;
            let btnDownload;
            let currentTr = div.closest('tr');
            if (!isMultiTable) {
                if (!document.querySelector(divDocContentId)) {
                    currentTr.insertAdjacentHTML("afterEnd",
                        '<tr><td colspan="2"><div id="divDocLoad_' + formFieldName + '" ></div><div id="divDocContent_' + formFieldName + '"/></td></tr>');
                }
                divDocLoad = document.querySelector(divDocLoadId);
                divDocContent = document.querySelector(divDocContentId);
                btnDownload = document.querySelector(btnDownloadId)
            }
            else {
                if (!currentTr.nextSibling?.attributes || currentTr.nextSibling?.attributes['Id']?.value != 'docViewTr') {
                    currentTr.insertAdjacentHTML("afterEnd",
                        `<tr id="docViewTr"><td colspan="${div.closest('tbody tr').querySelectorAll('td').length}" id="docViewTd" ></td></tr>`
                    );
                }
                let docViewTr = currentTr.nextSibling;
                if (!docViewTr.querySelector(divDocContentId)) {
                    docViewTr.querySelector('#docViewTd').insertAdjacentHTML("beforeEnd",
                        '<div id="divDocLoad_' + formFieldName + '" ></div><div id="divDocContent_' + formFieldName + '"/><br>'
                    );
                }
                divDocContent = docViewTr.querySelector(divDocContentId);
                divDocLoad = docViewTr.querySelector(divDocLoadId);
                btnDownload = currentTr.querySelector(btnDownloadId)
            }

            if (!$(divDocLoad).children().length) {
                $(divDocLoad).append(
                    $("<div/>").addClass("box-body").text(mlMsgLoading)
                ).append(
                    $("<img/>").attr("src", "../common/images/v3/loading_ajax.gif")
                );
            }

            $(divDocLoad).css("display", "block").css("width", "100%").css("text-align", "center");

            var lastNameParts = path.split('/').pop().split('.');
            lastNameParts.pop();

            let url = "../document/preview_embed/" + lastNameParts[0] + viewerCrypt;

            $(divDocContent).load(url,
                function () {
                    $(divDocLoad).hide();
                }
            );

            $(btnDownload).remove();

            $(input).after(
                $('<button/>').attr('id', 'btnDownload_' + formFieldName)
                    .addClass('btn')
                    .css('margin-right', '1em')
                    .attr('onclick', 'event.preventDefault(); location.href = "../document/download/' + lastNameParts[0] + viewerCrypt + '"')
                    .text('Download')
            )
        }
    }
}

function isValidField(obj) {
    const isHidden = obj.type === "hidden";
    const xtype = cryo_GetObjectPropertyValue(obj, "xtype");
    const isFileType = xtype === "FILE";
    const isDataType = xtype === "DATA";

    //campo que não é hidden OU se for hidden, deve ter tipo FILE ou DATA
    return !isHidden || (isHidden && (isFileType || isDataType));
}
function validate() {
    var obj = null;
    var ret = "";
    var fields = "";
    var label = "";
    for (var i = 0; i < document.forms[0].elements.length; i++) {
        obj = document.forms[0].elements[i];
        if (true) {
            if ((obj.type == "checkbox" || obj.type == "radio") && obj.name != "inpToSign") {
                label = cryo_GetObjectPropertyValue(obj, "label");
                var objMul = document.getElementsByName(obj.name);

                if (fields.indexOf(obj.name + ";") < 0) {
                    if (cryo_GetObjectPropertyValue(obj, "required") == "S") {
                        var ok = false;

                        if (typeof (objMul.length) == "undefined") {
                            // o campo só possui uma opção então valida se está marcado
                            if (objMul.checked) {
                                ok = true;
                            }
                        } else {
                            // o campo possui várias opções então valida se alguma está marcada
                            for (var j = 0; j < objMul.length; j++) {
                                if (objMul[j].checked) {
                                    ok = true;
                                }
                            }
                        }
                        if (!ok) {
                            ret += "   " + label.toUpperCase() + ": " + mlMsgRequiredField + ".\n";
                        }
                    }
                }
            } else if (isValidField(obj)) { // validar campo do tipo Arquivo e tipo DATA que seja Obrigatório
                label = cryo_GetObjectPropertyValue(obj, "label");//obj.parentNode.parentNode.childNodes(0).innerHTML;
                var valRequired = false;
                /*Campo Obrigatório*/
                if (cryo_GetObjectPropertyValue(obj, "required") == "S" && obj.value == "") {
                    ret += "   " + label.toUpperCase() + ": " + mlMsgRequiredField + ".\n";
                    valRequired = true;
                }
                /*Validação da Expressão Regular*/
                let regexpa = cryo_GetObjectPropertyValue(obj, "regexpa");
                if (regexpa != null && regexpa != "" && obj.value != "") {
                    let reg = new RegExp(regexpa);
                    if (!reg.test(obj.value)) {
                        if (cryo_GetObjectPropertyValue(obj, "msgErrorRegular") != undefined && cryo_GetObjectPropertyValue(obj, "msgErrorRegular") != "") { // BUG 0004387 - 28/05/2009
                            ret += "   " + label.toUpperCase() + ": " + cryo_GetObjectPropertyValue(obj, "msgErrorRegular") + "\n";
                        } else {
                            ret += "   " + label.toUpperCase() + ": " + mlMsgInvalid + ".\n";
                        }
                    }
                }
                if (!valRequired) {
                    /*Tamanho maximo*/
                    if (cryo_GetObjectPropertyValue(obj, "maxlength") != undefined) {
                        if (cryo_GetObjectPropertyValue(obj, "maxlength") != "" && obj.value.length > 0) {
                            if (obj.value.length > cryo_GetObjectPropertyValue(obj, "maxlength")) {
                                ret += "   " + label.toUpperCase() + ": " + mlMsgMaxLength.replace("{0}", cryo_GetObjectPropertyValue(obj, "maxlength")) + ".\n";
                            }
                        }
                    }

                    /*Tamanho míninmo*/
                    if (cryo_GetObjectPropertyValue(obj, "minlength") != undefined) {
                        if (cryo_GetObjectPropertyValue(obj, "minlength") != "" && obj.value.length > 0) {
                            if (obj.value.length < cryo_GetObjectPropertyValue(obj, "minlength")) {
                                ret += "   " + label.toUpperCase() + ": " + mlMsgMinLength.replace("{0}", cryo_GetObjectPropertyValue(obj, "minlength")) + ".\n";
                            }
                        }
                    }
                }
            }
            fields += obj.name + ";";
        }
    }

    ret += getMsgCheckPositionArea();

    if (ret != "") {
        ret = mlMsgValidationErrors + ":\n" + ret;
        cryo_alert(ret);
        return false;
    } else {
        saveMessages();

        return true;
    }
}

function getMsgCheckPositionArea() {
    const positionAreaSelect = document.querySelector('select[name="inpCodPositionArea"]');
    if (positionAreaSelect && positionAreaSelect.value === "") {
        return ` ${mlMsgPositionAreaToStartProcess}`;
    }
    return "";
}

function validatePositionAreaCombo() {
    const message = getMsgCheckPositionArea();
    if (message !== "") {
        cryo_alert(message);
        return false;
    }
    return true;
}

function saveMessages() {
    var objMessage = $("input[name='inpDsMessageBody']");
    var objMessageRequester = $("input[name='inpStRequesterMessage']");

    var strMessage = "";
    var strMessageRequester = "";
    if (objMessage != null) {
        if (objMessage.length > 1) {
            for (var i = 0; i < objMessage.length; i++) {
                if (i > 0) {
                    strMessage += "$%$" + objMessage[i].value;
                    strMessageRequester += "$%$" + objMessageRequester[i].value;
                } else {
                    strMessage += objMessage[i].value;
                    strMessageRequester += objMessageRequester[i].value;
                }
            }
        } else if (objMessage.length == 1) {
            if (objMessage[0].value !== undefined && objMessageRequester[0].value !== undefined) {
                strMessage += objMessage[0].value;
                strMessageRequester += objMessageRequester[0].value;
            }
        }

        if (getObj("inpDsMessageAll") !== null) {
            getObj("inpDsMessageAll").value = strMessage.replaceAll('<br>', '\n');
        }
        if (getObj("inpDsMessageRequesterAll") !== null) {
            getObj("inpDsMessageRequesterAll").value = strMessageRequester;
        }
    }
}

function controlHistory() {
    var result;
    if ($("#tblHistoryComplete").hasClass('hidden') === true) {
        result = $("#tblHistoryComplete").removeClass('hidden');
        $(window).off('.affix');
        $("#ContainerHistory").removeData('affix').removeClass('affix affix-top affix-bottom');
        location.href = "#tblHistoryComplete";
    } else {
        result = $("#tblHistoryComplete").addClass('hidden');
    }

    return result;
}

// alterado por leonardo - 16/04/2008
// alterado por rafael - 30/05/2008
function removeWhiteSpaces(o) {
    var node = null;
    while (node = node ? node.nextSibling : o.firstChild) {
        if (node.nodeType == 3 && !/\S/.test(node.nodeValue)) {
            o.removeChild(node);
        }
    }
    if (node || o.firstChild) {
        while (node = node ? node.nextSibling : o.firstChild.firstChild) {
            if (node.nodeType == 3 && !/\S/.test(node.nodeValue)) {
                o.firstChild.removeChild(node);
            }
        }
    }
}

//alterado rafael 11/11/2008
var divNewForm = null;

function selectMultipleForm(v, o, consult) {
    if (consult == null) {
        consult = false;
    }
    $.post(URL_ROOT + "Workflow/wfFlow_Execute_Form.aspx?f=" + v + "&c=" + (consult ? '1' : '0'), function (data) {
        if (divNewForm == null) {
            divNewForm = document.createElement("div");
            var box = document.getElementById("BoxFrmExecute");
            box.appendChild(divNewForm);
        }
        divNewForm.innerHTML = data;
        fillForm();
    }).fail(function (e) {
        alert(mlMsgAjaxError.replace("{{errorcode}}", e));
    });
    noFill = o;
}

function reorderFiles(c) {
    var url = URL_ROOT + "WorkFlow/wfFlow_Execute_File_Xml.aspx?c=" + c;

    $.post(url, function (data) {
        if (data !== undefined) {
            var div = document.getElementById("divFile");
            var tbl = document.getElementById("tblFile");
            div.removeChild(tbl);
            div.innerHTML = data;
        }
    });
}

// 2013-06-12 Leonardo de Quadros Luzzatto
// Applies masks to form fields
// tableRow - its the multiple-value table newly added TR element
function applyMasksToFormFields(tableRow) {
    var selector, maxlength, numberMask;

    selector = '[mask*="9"],[mask*="A"],[mask*="NUMBER"],[mask*="MONEY"]';

    var applyMasks = function (i, v) {
        if ($(v).attr('mask') === "(99) 99999.9999" || $(v).attr('mask') === "(99) 9999.9999") {
            if ($(v).val().length === $(v).attr('mask').length) {
                // mascara e valor estao padronizados
                $(v).mask($(v).attr('mask'), cellphone9DigitOptions);
            } else if ($(v).val().length < $(v).attr('mask').length) {
                // 10/05/2016 - Leonardo Luzzatto - Correcao bug 29200
                if ($(v).val().length == "(99) 9999.9999".length) {
                    $(v).mask("(99) 9999.9999", cellphone9DigitOptions);
                } else if ($(v).val().length == "(99) 99999.9999".length) {
                    $(v).mask("(99) 99999.9999", cellphone9DigitOptions);
                } else {
                    // 10/05/2016 - Leonardo Luzzatto - Correcao bug 29200
                    $(v).mask($(v).attr('mask'), cellphone9DigitOptions);
                }
            } else {
                // valor é maior do que a mascara
                $(v).mask("(99) 99999.9999", cellphone9DigitOptions);
            }
        }
        else if ($(v).attr('mask') === "AAA9A99" || $(v).attr('mask') === "AAA99A9" || $(v).attr('mask') === "AAA-9999") {
            var letterReg = /[a-z]/i;
            if ($(v).val()[3] === '-' || $(v).val().length < 3) {
                $(v).mask('SSSZ9999', placaOptions);
            } else if ($(v).val()[4].match(letterReg)) {
                $(v).mask('SSS9S99', placaOptions);
            } else if ($(v).val()[5].match(letterReg)) {
                $(v).mask('SSS99A9', placaOptions);
            }
        }
        else if ($(v).attr('mask').toUpperCase() === "NUMBER") {
            maxlength = parseInt($(v).attr('maxlength'), 10);

            if (!isNaN(maxlength)) {
                numberMask = Array(maxlength + 1).join("0");
            } else {
                numberMask = "00000000000000000";
            }

            $(v).mask(numberMask, { reverse: true });
        } else if ($(v).attr('mask').toUpperCase() === "MONEY") {
            var moneyMask = '000.000.000.000.000,00';
            var moneyMaxlength = $(v).attr('maxlength');

            if (moneyMaxlength !== '') {
                moneyMaxlength = parseInt(moneyMaxlength, 10);

                if (moneyMask.length > moneyMaxlength) {
                    moneyMask = moneyMask.substr(moneyMask.length - moneyMaxlength);
                }
            }

            $(v).mask(moneyMask, { reverse: true });

            // mascara MONEY, ao preecher o primeiro caractere tornar o valor monetario
            $(v).keyup(function (sender) {
                var val = $(this).val();

                if (val != '') {
                    if (val.length < 3 && val.indexOf(',') == -1) {
                        val = '0,' + val;
                    } else {
                        if (val.substr(0, 1) === '0' && val.substr(1, 1) !== ',') {
                            val = val.substring(1);
                        }
                    }
                    $(this).val(val);
                }
            });
        } else if ($(v).attr('mask').toUpperCase() === "EMAIL") {
            //TODO: máscara de e-mail ME 1.0
        } else if (execv.util.isAlphanumericCnpjMask($(v).attr('mask'))) {
            var convertedMask = $(v).attr('mask').replace(/\*/g, 'A').replace(/##/g, '99');
            $(v).mask(convertedMask);

            $(v).on('keyup', function() {
                var cursorPos = this.selectionStart;
                var val = $(this).val();
                var upperVal = val.toUpperCase();
                if (val !== upperVal) {
                    $(this).val(upperVal);
                    this.setSelectionRange(cursorPos, cursorPos);
                }
            });
        } else {
            $(v).mask($(v).attr('mask'));
        }
    };

    if (tableRow === undefined) {
        // its running this function for the first time
        $.each($(selector), function (i, v) { applyMasks(i, v); });
    } else {
        // its running this function again because of a multiple-value table
        $.each($(tableRow).find(selector), function (i, v) { applyMasks(i, v); });
    }

    if (tableRow !== undefined) {
        // runs only when its being called by a multiple-value table line insertion
        if (typeof cryo_setMaskDate !== 'undefined' && cryo_setMaskDate) {
            cryo_setMaskDate(tableRow);
        }
    }
}

//2013-07-25 - Rafael Bortolini
//Open the forward colorbox
function cryo_openForward() {
    $.colorbox({ inline: true, href: ".forward-box", width: (clientIsMobile ? "99%" : "50%") });
    cryo_configTypehead("inpDsUserForwardTo", "inpCodUserForwardTo", true, true);
}

//2013-07-25 - Rafael Bortolini
//Submits the forward instruction
function cryo_forward() {
    if ($("#inpCodUserForwardTo").val() != "") {
        $.getJSON(URL_ROOT + "api/internal/legacy/1.0/execute/taskposition.aspx?m=isalreadyowner&t=" + $("#inpCodFlowExecuteTask").val() + "&u=" + $("#inpCodUserForwardTo").val(),
            function (data) {
                var html = '';
                if (data.success != null) {
                    if (!data.success) {
                        $.colorbox.close();
                        cryo_appOpenLoading();
                        $("#inpDsNameUserForwardTo").val($("#inpDsUserForwardTo").val());
                        if ($("#inpDsForwardMessage").val() != $("#inpDsForwardMessage").attr("placeholder"))
                            addMessageLineAjax($("#inpDsForwardMessage").val(), "", true, true);
                        hideControllerBlock();
                        getObj("inpAction").value = "FORWARD";
                        getObj("__VIEWSTATE").value = "";
                        getObj("frm").action = getExecutionPage();
                        getObj("frm").target = "ifrmProcess";
                        getObj("frm").submit();
                    } else {
                        alert(mlMsgUserAlreadyOwner);
                    }
                }
            }
        );
    } else {
        $(".forward-box .text-error").show();
    }
}

//2013-07-25 - Rafael Bortolini
//Open the cancel colorbox
function cryo_openCancel() {
    $.colorbox({ inline: true, href: ".cancel-box", width: (clientIsMobile ? "99%" : "50%") });
}

//2013-07-25 - Rafael Bortolini
//Submit the cancel instruction
function cryo_cancel() {
    $.colorbox.close();
    cryo_appOpenLoading();
    if ($("#inpDsCancelMessage").val() != $("#inpDsCancelMessage").attr("placeholder"))
        addMessageLineAjax($("#inpDsCancelMessage").val(), "", true, true);
    hideControllerBlock();
    getObj("inpAction").value = "CANCEL";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    getObj("frm").submit();
}

//2013-07-25 - Rafael Bortolini
//Open the askopinion colorbox
function cryo_openAskOpinion() {
    $.colorbox({ inline: true, href: ".askopinion-box", width: (clientIsMobile ? "99%" : "50%") });
    cryo_configTypehead("inpDsUserAskOpinionTo", "inpCodUserForwardTo", true, true);
}

//2013-07-25 - Rafael Bortolini
//Submit the askopinion instruction
function cryo_askOpinion() {
    if ($("#inpCodUserForwardTo").val() != "") {
        $.getJSON(URL_ROOT + "api/internal/legacy/1.0/execute/taskposition.aspx?m=isalreadyowner&t=" + $("#inpCodFlowExecuteTask").val() + "&u=" + $("#inpCodUserForwardTo").val(),
            function (data) {
                var html = '';
                if (data.success != null) {
                    if (!data.success) {
                        $.colorbox.close();
                        cryo_appOpenLoading();
                        $("#inpDsNameUserForwardTo").val($("#inpDsUserAskOpinionTo").val());
                        if ($("#inpDsAskOpinionMessage").val() != $("#inpDsAskOpinionMessage").attr("placeholder"))
                            addMessageLineAjax($("#inpDsAskOpinionMessage").val(), "", true, true);
                        hideControllerBlock();
                        getObj("inpAction").value = "ASKOPINION";
                        getObj("__VIEWSTATE").value = "";
                        getObj("frm").action = getExecutionPage();
                        getObj("frm").target = "ifrmProcess";

                        getObj("frm").submit();
                    } else {
                        alert(mlMsgUserAlreadyOwner);
                    }
                }
            }
        );
    } else {
        $(".askopinion-box .text-error").show();
    }
}
//2013-07-25 - Rafael Bortolini
//Submit the response for the askopinion
function cryo_returnAfterOpinion() {
    cryo_appOpenLoading();
    hideControllerBlock();
    getObj("inpAction").value = "RETURNOPINION";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    getObj("frm").submit();
}

//2013-07-25 - Rafael Bortolini
//Open the takeback colorbox
function cryo_openTakeBack() {
    $.colorbox({ inline: true, href: ".takeback-box", width: (clientIsMobile ? "99%" : "50%") });

    $.getJSON(URL_ROOT + "api/internal/legacy/1.0/execute/history.aspx?m=take-back&cfe=" + $("#inpCodFlowExecute").val(),
        function (data) {
            var html = '';
            if (data.success != null) {
                $("#inpCodElementToTakeBack").empty();
                $.each(data.success, function (index, item) {
                    if (data.success[index].c != $("#inpCodFlowElement").val()) {
                        html += '<option value="' + data.success[index].c + '">' + data.success[index].t + '</option>';
                    }
                });
                if (html != "") {
                    $("#inpCodElementToTakeBack").append(html);
                } else {
                    $("#takeback-form").hide();
                    $("#takeback-empty").show();
                }
            }
        });
}

//2013-07-25 - Rafael Bortolini
//Submit the takeback instruction
function cryo_takeBack(takebackresult) {
    $("#inpDefinedCodToElement").val($("#inpCodElementToTakeBack").val());
    if ($("#inpDsTakeBackMessage").val() != $("#inpDsTakeBackMessage").attr("placeholder")) {
        addMessageLineAjax($("#inpDsTakeBackMessage").val(), "", true, true);
    }
    cryo_appOpenLoading();
    $.colorbox.close();
    getObj("inpDsFlowResult").value = takebackresult;
    hideControllerBlock();
    getObj("inpAction").value = "UPDATE";
    getObj("__VIEWSTATE").value = "";
    getObj("frm").action = getExecutionPage();
    getObj("frm").target = "ifrmProcess";
    getObj("frm").submit();
}

function cryo_seeReport(c) {
    window.open(URL_ROOT + "workflow/wfrel_tracker_detail.aspx?c=" + c);
}

function cryo_seeModelling(c) {
    window.open(URL_ROOT + "designer/readonly.aspx?c=" + c);
}

var nextPossibleTask;

function parseNextPossibleTask(data) {
    var accumulator, htmlTemplate, percent, statistics, limit, tdClass, cellCount, width;

    tdClass = '';
    accumulator = 0;
    cellCount = 0;
    percent = 0;
    width = 0;

    limit = 3;
    //limit = 9999;

    //htmlTemplate = '<table id="tableStatistics" class="table striped"><thead><tr><th>' + mlTitleNextStep + '</th><th>' + mlLblResult + '</th><th>' + mlLblQuantity + '</th><th>%</th></tr></thead><tbody>{{rows}}</tbody></table>';
    //htmlTemplate = '<div class="spaced clearfix">{{rows}}</div><br>';
    htmlTemplate = '<table class="table table-bordered"><tr>{{rows}}</tr></table>';

    if (data.success != null && data.success.length > 0) {
        // store data in global variable
        statistics = data.success;

        // calculate total results
        $.each(statistics, function (index, item) {
            accumulator = accumulator + parseInt(statistics[index].count, 10);
        });

        // console.log(statistics.length);

        if (statistics.length > 0) {
            if (statistics.length <= 3) {
                width = Math.round(100 / statistics.length);
                width = width - (width * 0.04);
            } else {
                width = 31;
            }
        }

        // destiny-table

        var rowTemplate = '<tr><td class="col-0">';
        rowTemplate += '<label for="{{input-id}}" class="radio">';
        rowTemplate += '<input type="radio" name="{{input-name}}" id="{{input-id}}" value="{{codflowelement}}" required> {{dstasktitle}}';
        rowTemplate += '</label></td>';
        rowTemplate += '<td class="col-1">';
        rowTemplate += '<label for="{{input-id}}"><strong>{{percentage}} %</strong></label>';
        rowTemplate += '</td></tr>';

        var row = '';
        $.each(statistics, function (index, item) {
            if (accumulator == 0) {
                percent = 0;
            } else {
                percent = (100 * parseInt(statistics[index].count, 10)) / accumulator;
                percent = Math.round(percent * 100) / 100;
                percent = percent.toString().replace('.', ',');
            }

            row = rowTemplate;
            row = row.replace(/\{\{input\-id\}\}/gi, 'chk-adhoc-' + index.toString());
            row = row.replace('{{input-name}}', 'inpDefinedCodToElementAux');
            row = row.replace('{{codflowelement}}', statistics[index].codFlowElement);
            row = row.replace('{{dstasktitle}}', statistics[index].task);
            row = row.replace('{{percentage}}', percent);
            $('#destiny-table').append(row);
        });
    } else {
        // no data
        $('#destiny-table').append('<tr><td class="col-0">' + mlMsgTaskStatisticsNotAvaliable + '</td></tr>');
    }
}

function cryo_buildNextPossibleTask(codTask, codFlow) {
    // request statistics via JSON
    if (nextPossibleTask === undefined) {
        $.getJSON(URL_ROOT + "api/internal/legacy/1.0/execute/nextpossibletask.aspx?t=" + codTask + "&f=" + codFlow, function (data) {
            nextPossibleTask = data;
            parseNextPossibleTask(nextPossibleTask);
        });
    } else {
        parseNextPossibleTask(nextPossibleTask);
    }
}

function validateAdHoc(existingOrNewTask) {
    var validate = false;

    if ($('#inpAdHoc').val() === 'N') {
        validate = true;
    } else {
        // copy data from colorbox to flowexecute.aspx
        $('#inpAdHocDsTaskTitle').val($('#inpAdHocDsTaskTitle_').val());
        $('#inpAdHocActor').val($('#inpAdHocActor_').val());
        $('#inpAdHocCodUser').val($('#inpAdHocCodUser_').val());
        $('#inpAdHocDeadline').val($('#inpAdHocDeadline_').val());
        $('#inpAdHocDsTask').val($('#inpAdHocDsTask_').val());

        $('#inpDefinedCodToElement').val($('input[name="inpDefinedCodToElementAux"]:checked').val());

        if (existingOrNewTask === 'existing-task') {
            validate = ($('input[name="inpDefinedCodToElementAux"]:checked').val() !== undefined);
        } else {
            validate = ($('#inpAdHocDsTaskTitle').val() !== '' &&
                $('#inpAdHocActor').val() !== '' &&
                $('#inpAdHocDeadline').val() !== ''/* &&
                $('#inpAdHocDsTask').val() !== ''*/);
        }

        if (!validate) {
            alert(mlMsgAdHocNextStep);
        }
    }

    return validate;
}

function adHocActorTypeAhead() {
    $("#inpAdHocActor_").typeahead({
        minLength: 3,
        source: function source(query, process) {
            $.ajax({
                url: URL_ROOT + 'api/internal/legacy/1.0/User/UserNames.aspx?activeOnly=1&includeCode=1',
                dataType: 'json',
                async: true,
                data: 'inpDsName=*' + query + '*',
                success: function (data) {
                    inpCodUserNames = [];
                    inpCodUserNamesAndCodes = [];
                    $.each(data, function (i, o) {
                        var code, name;

                        if (o.indexOf('___') > -1) {
                            code = o.substring(o.indexOf('___') + 3);
                            name = o.substring(0, o.indexOf('___'));
                            inpCodUserNames.push(name);
                            inpCodUserNamesAndCodes.push({ "code": code, "name": name });
                        }
                    });
                    process(inpCodUserNames);
                }
            });
        },
        updater: function (data) {
            $.each(inpCodUserNamesAndCodes, function (i, o) {
                if (o.name == data) {
                    $('#inpAdHocCodUser_').val(o.code);
                }
            });
            return data;
        }
    });
}

function changeButtonEvents() {
    // 27/08/2014 - Leonardo
    // o botao de finalizar tarefa (seja qual for) deve:
    // 1. realizar validacoes basicas
    // 2. abrir o colorbox
    //
    // o botao de finalizar ou criar tarefa adhoc deve:
    // 1. chamar o evento onclick do botao original
    var originalEventArray = [];
    $('#buttons button[data-type!="cancel"][data-reason!="true"]').each(function (i, o) {
        originalEventArray.push({ id: $(o).prop('id'), event: $(o)[0].onclick });
        $(o).off();
        $(o)[0].onclick = null;
        $(o).prop('onclick', null);

        $(o).click(function (event) {
            var originalEvent;
            var validateResult, attachedFilesResult, signPostResult, messageWaitingResult, validateLogHoursResult;

            $(originalEventArray).each(function (i, o) {
                if (o.id == event.currentTarget.id) {
                    originalEvent = o.event;
                }
            });

            validateResult = validate();

            if (validateResult) {
                attachedFilesResult = attachedFiles();
                signPostResult = signPost();
                messageWaitingResult = messageWaiting();
                validateLogHoursResult = validateLogHours();

                if (attachedFilesResult && signPostResult && messageWaitingResult && validateLogHoursResult) {
                    $('#adhoc-next-task-main').removeClass('hidden');
                    $('#adHocMain').addClass('hidden');
                    $.colorbox({ inline: true, href: '#adhoc-next-task', width: '40%' });

                    $('#btnSelectAdhocTest').on('click', function () {
                        if (!validateAdHoc('existing-task')) {
                            return false;
                        }
                        originalEvent();
                    });
                    $('#btnCreateAdHocTask').on('click', function () {
                        if (!validateAdHoc('new-task')) {
                            return false;
                        }
                        originalEvent();
                    });
                }
            }
        });
    });
}

function adHocLinkEventHandler() {
    $('#linkCreateNextTask').prop('href', 'javascript:void(0)').click(function (e) { e.stopPropagation(); $('#adhoc-next-task-main').addClass('hidden'); $('#adHocMain').removeClass('hidden'); return; });
    $('#linkChooseNextTask').prop('href', 'javascript:void(0)').click(function (e) { e.stopPropagation(); $('#adhoc-next-task-main').removeClass('hidden'); $('#adHocMain').addClass('hidden'); return; });
}

function countTasks() {
    var shouldCountTasks = true;

    function countTasksJson() {
        var codFlowExecute, numberOfTasks;

        codFlowExecute = $('#inpCodFlowExecuteC').val();
        numberOfTasks = $('#inpNumberOfTasks').val();

        if (shouldCountTasks && codFlowExecute !== '') {
            $.ajax({
                dataType: "json",
                url: URL_ROOT + 'api/internal/legacy/1.0/execute/numberoftasks.aspx',
                data: 'c=' + codFlowExecute,
                global: false,
                success: function (data, textStatus, jqXHR) {
                    if (data && data.success && data.success.tasks) {
                        if (numberOfTasks !== '') {
                            numberOfTasks = parseInt(numberOfTasks, 10);

                            if (!isNaN(numberOfTasks) && !isNaN(data.success.tasks)) {
                                if ((data.success.tasks > numberOfTasks) && !window.finishTask) {
                                    $('#controllers button').hide();

                                    $('#controllers a').hide();

                                    $('#divAnotherTaskWasFinalized').removeClass('hidden');

                                    // scroll to top
                                    window.scrollTo(0, 0);

                                    // stop querying
                                    shouldCountTasks = false;
                                }
                            }
                        }
                    } else {
                        shouldCountTasks = false;
                    }
                },
                error: function () {
                    shouldCountTasks = false;
                }
            });
        }
    }
    countTasksJson();
}

function isTaskOwned() {
    var inpCodFlowExecuteTask = $("#inpCodFlowExecuteTask").val();
    var shouldCheckOwnerShip = inpCodFlowExecuteTask !== "" && inpCodFlowExecuteTask !== "0";

    function iAmTheOwner() {
        if (!globalThis.parent.location.pathname.includes('1.0/task')
            && !globalThis.parent.location.pathname.includes('1.0/request')
            && globalThis.isTaskOwnedId) {
            globalThis.clearInterval(globalThis.isTaskOwnedId);
            globalThis.isTaskOwnedId = null;
            
            return;
        }

        if (shouldCheckOwnerShip) {
            $.ajax({
                dataType: "json",
                url: URL_ROOT + 'api/internal/legacy/1.0/execute/taskposition.aspx?m=iamtheowner',
                data: 't=' + inpCodFlowExecuteTask,
                global: false,
                success: function (data, textStatus, jqXHR) {
                    if (data !== null && !data.success) {
                        window.location.reload();
                    } else if (!window.finishTask) {
                        countTasks();
                    }
                },
                error: function () {
                    shouldCheckOwnerShip = false;
                }
            });
        }
    }

    iAmTheOwner();
    window.isTaskOwnedId = window.setInterval(iAmTheOwner, 10000);
}

function cryo_messageMentionUser(mentionFieldId, codUsersId) {
    const messageUserToNotify = [];
    const mentionRegex = new RegExp(/@[\S]*/g);
    const mentionField = $("#" + mentionFieldId);
    const codUsersField = $("#" + codUsersId);


    mentionField.attr('autocomplete', 'off').typeahead({
        minLength: 3,
        items: 20,
        source:
            function source(query, process) {
                if (query.indexOf('@') >= 0) {
                    let username;

                    //loop on all ocurrencies
                    while ((username = mentionRegex.exec(query)) !== null) {
                        let alreadyProcessedUser = false;
                        username = username.toString().replace("@", "").replace(/[,\s]/g, "");
                        if (username.length > 2) {
                            $.each(messageUserToNotify, function (i, user) {
                                if (user.dsusername === username || username.startsWith(user.dsusername)) {
                                    alreadyProcessedUser = true;
                                }
                            });

                           if (!alreadyProcessedUser) {
                                const usernameEncoded = encodeURIComponent(username);
                                let url = `${URL_ROOT}api/internal/bpms/1.0/users/search?isactive=true&includeusername=true&differentfromcurrentuser=true&name=${usernameEncoded}`;
                                let headers = {
                                    "Content-Type": "application/json"
                                };
                                let afToken = document.querySelector("input[name=__RequestVerificationToken]");
                                if (afToken) {
                                    headers["X-SML-AntiForgeryToken"] = afToken.value;
                                }

                                fetch(url, { method: "GET", headers })
                                    .then(response => {
                                        if (!response.ok) {
                                            throw new Error(`Erro ao buscar usuários: ${response.statusText}`);
                                        }
                                        return response.json();
                                    })
                                    .then(result => {
                                        const names = [];

                                        if (Array.isArray(result.success)) {
                                            result.success.forEach(user => {
                                                let userFormated = formatTypehead(user.id, user.nm, user.ph, user.usn, user.in, user.cl);
                                                names.push(userFormated);
                                            });
                                        }
                                        process(names);
                                    })
                                    .catch(error => console.error("Erro na requisição para o servidor:", error));

                            }
                        }
                    }

                    let msg = query;
                    $.each(messageUserToNotify, function (i, user) {
                        if (user != null) {
                            if (msg.indexOf("@" + user.dsusername) < 0) {
                                messageUserToNotify.splice(i, 1);
                            }
                        }
                    });

                    let $v = codUsersField;
                    $v.val('');
                    $.each(messageUserToNotify, function (i, user) {
                        $v.val($v.val() + ($v.val().length > 0 ? "," : ""));
                        $v.val($v.val() + (user.coduser));
                    });
                }
            },
        matcher: function (item) {
            return true;
        },
        updater: function (item) {
            function getCaret(el) {
                if (el.selectionStart) {
                    return el.selectionStart;
                } else if (document.selection) {
                    el.focus();

                    let r = document.selection.createRange();
                    if (r == null) {
                        return 0;
                    }

                    let re = el.createTextRange(),
                        rc = re.duplicate();
                    re.moveToBookmark(r.getBookmark());
                    rc.setEndPoint('EndToStart', re);

                    return rc.text.length;
                }
                return 0;
            }

            const userId = $(item).attr("userid");
            const username  = $.trim($(item).find(".muted").text());
            let data = this.query;
            let caratPos = getCaret(this.$element[0]);
            let i;
            for (i = caratPos; i >= 0; i--) {
                if (data[i] == "@") {
                    break;
                }
            }
            messageUserToNotify.push({ dsusername: username .replace("@", ""), coduser: userId });

            let textBefore = data.substring(0, i);
            let textAfter = data.substring(caratPos);
            data = textBefore + username  + textAfter;

            let $v = codUsersField;
            $v.val('');
            $.each(messageUserToNotify, function (i, user) {
                $v.val($v.val() + ($v.val().length > 0 ? "," : ""));
                $v.val($v.val() + (user.coduser));
            });

            return data;
        }
    });
}

function formatTypehead(coduser, name, photo, username, initials, color) {
    let nameFormated = name.split("(")[0].trim();
    let htmlTemplate = `<div class="user user-small" userid="${coduser}">`;

    if (photo && !photo.endsWith(DefaultPhoto)) {
        htmlTemplate += `
            <div class="user-photo" style="background-image: url(${photo})">
                <img src="${photo}">
            </div>`;
    } else {
        htmlTemplate += `
            <div class="user-photo color-${color}">
                <abbr class="initials initials-text">${initials}</abbr>
            </div>`;
    }

    htmlTemplate += `
        <div class="bold">${nameFormated}</div>
        <span class="muted">@${username}</span>
    </div>`;

    return htmlTemplate;
}


function calculateMinutesFromHours(valueInHours) {
    var newMinutes = '';
    var currentMinutes = $("#inpNbLogMinutesOriginal").val();

    if (valueInHours === "" || valueInHours === $("#inpNbLogHours").attr('placeholder')) {
        // se está vazio nao deve retornar o valor corrente via newMinutes
    } else {
        if (currentMinutes !== '') {
            newMinutes = parseInt(currentMinutes, 10);
        }

        newMinutes += parseInt($("#inpNbLogHours").val().split(':')[0] * 60, 10) +
            parseInt($("#inpNbLogHours").val().split(':')[1], 10);
    }

    return newMinutes;
}

function calculateHoursFromMinutes() {
    if ($("#inpNbLogMinutes").val() != "" && !isNaN($("#inpNbLogMinutes").val())) {
        var currval = parseInt($("#inpNbLogMinutes").val());
        if (currval < 60) return "00:" + currval;
        var minutes = currval % 60;
        var hours = (currval - (currval % 60)) / 60;
        return (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes);
    } else {
        return '00:00';
    }
}

// deve pegar o que o usuario digitou no campo e incrementar na contagem total
function incrementNbLogMinutes() {
    var minutes = calculateMinutesFromHours($("#inpNbLogHours").val());
    $("#inpNbLogMinutes").val(minutes);

    var vlHourValue = $("#inpVlManHourValue").val();
    if (vlHourValue !== undefined && vlHourValue != '') {
        var vlCost = parseFloat(vlHourValue.replace(',', '.')) * (parseFloat(minutes) / parseFloat(60)) + '';
        $('#inpVlCost').val(vlCost.replace('.', ','));
    }
}

$(document).ajaxStart(function () {
    let buttons = document.querySelector("#buttons");
    buttons?.classList.remove('d-flex');
    buttons?.classList.add('d-none');
    $("#buttons-waiting").show();
});

$(document).ajaxStop(function () {
    let buttons = document.querySelector("#buttons");
    buttons?.classList.remove('d-none');
    buttons?.classList.add('d-flex')
    $("#buttons-waiting").hide();
});

// Procura por campos de nomes associados a SELECT.
//essa funcao é chamada no load da wfflow_Execute
function cryo_processSelect() {
    //Se acha, salva o texto do option selecionado em um campo com mesmo identificador e inicio "nome"
    $("select[xname]").each(function () {
        var $select = $(this);
        var $parent = $select.parent();

        //o elemento que armazena o nome
        //se encontrar mais de um, quer dizer que é uma tabela MV, então procura de outra maneira, na linha
        var name_field = "inpnome" + $select.attr("xname").replace("inp", "");
        var $name_field = $("[xname='" + name_field + "']");
        if ($name_field.length > 1) {
            $name_field = $select.closest("tr").find("[xname='" + name_field + "']");
        }

        if ($name_field.length > 0) {
            $select.off("change.setNameField").on("change.setNameField", function () {
                if ($(this).val() != "") {
                    $name_field.val($select.find("option:selected").text());
                } else {
                    $name_field.val('');
                }
            });
        }
    });

    //Em campos do tipo SELECT que possuem outros campos associados, ao selecionar um item da caixa de seleção
    //Preenche os demais campos do formulario do ORquestra de acordo com o ID encontrado

    //quando ocorrer mudança na combo
    $("select[xname]").off("change.processFillOthers").on("change.processFillOthers", function () {
        //$("select option[data-others]").parent().off("change.processFillOthers").on("change.processFillOthers", function () {
        var $origin = $(this);
        var label = $origin.attr("label");
        var $option = $origin.find("option:selected");
        var others = $option.attr("data-others");
        var others_altered = [];
        //se possue valores de outros campos associados

        if (others && others != "") {
            var $json_others = $.parseJSON(others);
            //loop em cada campo
            $.each($json_others, function (k, v) {
                if ("inp" + k != $origin.attr("xname")) {
                    cryo_fillValue(k, v, $origin);

                    //registra que alterou esse campo
                    if ($.inArray(k, others_altered) == -1) {
                        others_altered.push(k)
                    }
                }
            });

            $origin.attr("others_altered", others_altered);
            //limpar os campos
        } else {
            others_altered = $origin.attr("others_altered") != null ? $origin.attr("others_altered").split(",") : [];

            $.each(others_altered, function (i, k) {
                cryo_fillValue(k, "", $origin);
            });
        }
    });
}

//função que faz um loop em todos os elementos que possuem dependencias, relacionadas a consultas de fontes de dados
//para cada dependencia encontrada, dispara evento no elemento de origem, para que ao mudar de valor, recarregue os dados da fonte de dados original
//essa funcao é chamada no load da wfflow_Execute
function cryo_processSubSelect(newRow, value) {
    if (newRow) {
        $(newRow).find("input[xname][data-dependencies][data-c]:not([data-special-type]), select[xname][data-dependencies][data-c]").each(function () {
            processSubSelect($(this), newRow, value);
        });
    }
    else {
        //loop em todas as combos que possuem dependencias, e tambem campos textos
        $("input[xname][data-dependencies][data-c]:not([data-special-type]), select[xname][data-dependencies][data-c]").each(function () {
            processSubSelect($(this));
        });
    }
}

function processSubSelect(self, newRow, value) {
    var $destiny = self;
    var label = $destiny.attr("label");
    var c = $destiny.attr("data-c");
    var dependencies = $destiny.attr("data-dependencies").split(',');
    var xname = $destiny.attr("xname");

    for (var i = 0; i < dependencies.length; i++) {
        var dependency = dependencies[i];
        var xname_origin = "inp" + dependency;

        //procura o elemento de origem, que ira popular esse select
        //se encontra mais de um, entao esta em multivalorada
        //nesse caso, procura entao na linha da tabela do elemento de destino
        var $origin = $("form").find("[xname='" + xname_origin + "']").length == 1 ?
            $("form").find("[xname='" + xname_origin + "']") :
            $destiny.parents("tr").find("[xname='" + xname_origin + "']");

        if (newRow) processDependencies($destiny, c, value != null ? { value: value } : null, label);

        $origin.on("change.processDependencies." + xname, function (x, initialValue) {
            processDependencies($destiny, c, initialValue, label);
        });
    }
}

function processDependencies($destiny, c, initialValue, label) {
    var $origin = $(this);
    var $container = $destiny.parent();
    var qs = "";
    var all_dp_filled = true;
    //array com os codigos dos elementos initialValue
    var dependencies = $destiny.attr("data-dependencies").split(",");
    // se tem tabela multivalorada entao requisicao sincrona
    var requestAsync = (document.querySelectorAll('table[mult="S"]').length > 0) ? false : true;

    //monta querystring com valores do formulario preenchidos
    for (const dependency of dependencies) {
        if (qs != "") {
            qs += "&";
        }

        var xname = "inp" + dependency;
        var xvalue = $("form").find("input[xname='" + xname + "'][type=radio]:checked, [xname='" + xname + "']:not([type=radio])").length == 1 ?
            $("form").find("[xname='" + xname + "'][type=radio]:checked, [xname='" + xname + "']:not([type=radio])").val() :
            $destiny.parents("tr").find("[xname='" + xname + "'][type=radio]:checked, [xname='" + xname + "']:not([type=radio])").val();

        //P800 #38609
        if ((xvalue == null || xvalue == "") && initialValue)
            xvalue = initialValue.value;

        if (xvalue == null || xvalue == "")
            all_dp_filled = false;

        qs += xname + "=" + encodeURIComponent(xvalue);
    }

    //todos os campos dependentes foram preenchidos
    if (all_dp_filled) {
        if ($container.find(".loading").length == 0) {
            $container.append("<img src=\"../common/images/v3/loading_ajax.gif\" width=\"16\" class=\"loading\">");
        }

        $destiny.find("option").remove();

        $.ajax({
            type: "post",
            dataType: "json",
            url: "../api/internal/legacy/1.0/datasource/get/1.0/" + c,
            async: requestAsync,
            data: (qs != "" ? "&" + qs : "")
        }).done(function (data) {
            if (data.success != null) {
                //o campo de destino é uma combo
                if ($destiny.is("select")) {
                    if (data.cache) {
                        $destiny.attr("data-from-cache", true);
                    }
                    if (data.runtime) {
                        $destiny.attr("data-runtime", data.runtime);
                    }
                    if (data.bytes) {
                        $destiny.attr("data-bytes", data.bytes);
                    }

                    $destiny.find("option").remove();

                    $destiny.append("<option value=\"\">" + mlLblSelectAnOption + "</option>");

                    $.each(data.success, function (i, item) {
                        $destiny.append("<option value='" + item.cod + "'" + (item.fields != null && item.fields != "" ? "data-others='" + JSON.stringify(item.fields) + "'" : "") + ">" + item.txt + "</option>");
                    });

                    if (initialValue) {
                        $destiny[0].value = initialValue.value;
                    }
                    //o campo de destino é input
                } else if ($destiny.is("input") && ($destiny.attr("type") != "hidden" || ($destiny.attr("type") == "hidden" && $destiny.attr("data-fieldformat") == "TEXT"))) {
                    var arrCods = new Array();
                    var ret = "";
                    $.each(data.success, function (i, item) {
                        if ($.inArray(item.cod, arrCods) == -1) {
                            if (ret != "") {
                                ret += ", ";
                            }
                            ret += item.txt;
                            arrCods.push(item.cod);

                            for (var f in item.fields) {
                                cryo_fillValue(f, item.fields[f], $origin, data.cache);
                            }
                        }
                    });
                    var maxlength = $destiny.attr("maxlength") != null ? $destiny.attr("maxlength") : 3000;
                    ret = ret.substring(0, maxlength);
                    var key_to_codfield = $destiny.attr("xname").replace("inp", "");
                    cryo_fillValue(key_to_codfield, ret, $origin, data.cache);
                }
            } else if (data.error != null) {
                cryo_processSubSelectError(label, data.error.FriendlyMessage);
            }
        })
            .fail(function (jqXHR, textStatus, errorThrown) {
                cryo_processSubSelectError(label, errorThrown);
            })
            .always(function () {
                $destiny.trigger("change");
                $container.find(".loading").remove();
            });
    }

    function cryo_processSubSelectError(label, message) {
        console.log(label + "\n" + message);
    }
}

// Inicializa o comportamento dos campos do tipo sugestão
// Executada no load da wfflow_Execute
function cryo_processSuggestions() {
    document.querySelectorAll("input[data-special-type='suggest'][data-c]").forEach(function (field) {
        const row = field.closest('tr');

        if (row && row.closest('table[mult=S]')) {
            setSuggestionField(field, row);
            return;
        }

        setSuggestionField(field);
    });
}

function cryo_processSuggestionsTable(newRow) {
    if (!newRow) return;
    newRow.querySelectorAll("input[data-special-type='suggest'][data-c]").forEach(function (field) {
        setSuggestionField(field, newRow);
    });
}

function setSuggestionField(suggestionField, row) {
    function cryo_processSuggestionsError(label, message) {
        console.log(label + "\n" + message);
    }

    var $suggest = $(suggestionField);
    var c = $suggest.attr("data-c");

    if (!c) return;

    var label = $suggest.attr("label");
    var options = [];
    var othersFieldsAltered = [];
    var $container = $suggest.parent();
    var timeout;
    var keyToCodField = "cod" + $suggest.attr("xname").replace("inp", "");
    let valueBefore = $suggest.val();

    //ao tirar o foco do campo
    $suggest.off("blur.processSuggestions").on("blur.processSuggestions", function () {
        const attr = $suggest.attr("data-setbytypeahed");

        if (!attr || attr === 'false' || !$suggest.val()) {
            $suggest.val('');

            cryo_fillValue(keyToCodField, '', $suggest);

            //limpa todas as referencias antes preenchidas
            othersFieldsAltered = $suggest.attr("others_altered") != null ? $suggest.attr("others_altered").split(",") : [];

            for (const field of othersFieldsAltered) {
                cryo_fillValue(field, '', $suggest);
            }
        }

        //após 4 milissegundos do evento de blur, se o valor do campo estiver diferente do valor original,
        //é disparado um evento de change, que é capturado pela automação de campos
        //o timeout evita que o evento seja disparado múltiplas vezes (quando o usuário inicia a digitação, quando o campo é limpado, etc)
        setTimeout(() => {
            let value = $suggest.val();
            if (value != valueBefore)
                $suggest[0].dispatchEvent(new Event('suggest-change'));
        }, 400);
    });

    //o valor do campo foi preenchido pelo usuário e não pela consulta ajax
    $suggest.off("keypress.processSuggestions").on("keypress.processSuggestions", function () {
        $suggest.attr("data-setbytypeahed", false);
    });

    $suggest.typeahead({
        minLength: 3,
        source: function source(query, process) {
            clearTimeout(timeout);

            //timeout para melhorar a experiencia de digitação e economizar postbacks
            timeout = setTimeout(function () {
                //mostra o loading
                if ($container.find(".loading").length == 0) {
                    $container.append('<img src="../common/images/v3/loading_ajax.gif" width="16" class="loading">');
                }

                const optionsText = [];
                options = [];

                const queryString = getQueryStringOfFieldsFromRowAndOutsideMultipleTable(row);

                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: "../api/internal/legacy/1.0/datasource/get/1.0/" + c,
                    data: `f=${encodeURIComponent(query)}&n=10&${queryString}`
                })
                    .done(function (data) {
                        if (data.success != null) {
                            data.success.forEach(function (option) {
                                if (!optionsText.includes(option.txt)) {
                                    optionsText.push(option.txt);
                                }
                                options.push(option);
                            });

                            process(optionsText);
                        }
                        else if (data.error != null) {
                            cryo_processSuggestionsError(label, data.error.FriendlyMessage);
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        cryo_processSuggestionsError(label, errorThrown);
                    })
                    .always(function () {
                        $container.find(".loading").remove();
                    });
            }, 300);
        },
        matcher: function (item) {
            return true
        },
        updater: function (txt, autoLoad) {
            $suggest.attr("data-setbytypeahed", true);

            if (txt === undefined) return;

            const selectedOption = options.find(function (option) {
                return option.txt == txt || (autoLoad && option.cod == txt);
            });

            if (!selectedOption) return;

            cryo_fillValue(keyToCodField, selectedOption.cod, $suggest);

            for (const field in selectedOption.fields) {
                if (('inp' + field) === $suggest.attr('xname')) continue;

                cryo_fillValue(field, selectedOption.fields[field], $suggest);

                if (!othersFieldsAltered.includes(field)) {
                    othersFieldsAltered.push(field);
                }
            }

            $suggest.attr("others_altered", othersFieldsAltered);

            //após 4 milissegundos do item selecionado é disparado um evento de change, que é capturado pela automação de campos
            //o timeout permite que o valor retornado pela função updater seja setado no campo antes do evento disparar
            setTimeout(() => {
                $suggest[0].dispatchEvent(new Event('suggest-change'));
            }, 400);

            return txt;
        }
    });

    //Douglas Pinheiro: 19/01/2017
    //Se o campo sugestão já possui um valor carregado na primeira tarefa, a fonte de dados é imediatamente executada.
    //Isso é feito apenas na primeira tarefa para evitar perda de dados (sobrescrita)
    if ($suggest.val() && !$("#inpCodFlowExecute").val()) {
        $suggest.data('typeahead').source($suggest.val(), function () {
            $($suggest).data('typeahead').updater($suggest.val(), true);
        });
    }

    $suggest.on('focus', (e) => {
        valueBefore = $suggest.val();
    });
}

function getFieldsFromRowAndOutsideMultipleTable(row) {
    const fieldsSelector =
        'input[xname]:not([type=checkbox]):not([type=radio]), input[xname]:checked, select[xname], textarea[xname]';
    const boxFrmExecute =
        document.getElementById('BoxFrmExecute') ||
        document.getElementById('FrmExecute');

    const allFields = boxFrmExecute.querySelectorAll(fieldsSelector);

    if (allFields === null) return [];

    if (!row) return Array.from(allFields);

    const fieldsOutsideMultipleTable = [];
    const fieldsFromRow = Array.from(row.querySelectorAll(fieldsSelector));

    allFields.forEach(function (field) {
        const fieldXname = field.attributes.xname.value;

        if ((fieldsFromRow.find((fieldFromRow) => fieldFromRow.attributes.xname.value === fieldXname))) return;

        fieldsOutsideMultipleTable.push(field);
    });

    return [...fieldsFromRow, ...fieldsOutsideMultipleTable];
}

function getQueryStringOfFieldsFromRowAndOutsideMultipleTable(row) {
    return getFieldsFromRowAndOutsideMultipleTable(row)
        .map(field => `${field.attributes.xname.value}=${encodeURIComponent(field.value)}`)
        .join('&');
}

///função que permite o funcionamento dos novos campos do tipo pesquisar e preencher
function cryo_processSearchAndFill() {
    function cryo_processSearchAndFilError(label, message) {
        console.log(label + "\n" + message);
    }

    //todos os elementos do tipo pesquisar e preencher
    $("input[data-special-type='search-and-fill']").each(function () {
        var $field = $(this);
        var label = $field.attr("label");
        var timeout;
        var $container = $field.parents(".search-and-fill-container");

        var $this_xname = $(this).attr("xname");
        //o botao associado a esse elemento
        var $btn = $("button[data-search-and-fill-for='" + $this_xname + "']");
        if ($btn.length > 0) {
            $btn = $field.parent().find("button[data-search-and-fill-for='" + $this_xname + "']");
        }

        //o elemento que armazena o codigo
        //se encontrar mais de um, quer dizer que é uma tabela MV, então procura de outra maneira, na linha
        var key_to_codfield = "cod" + $field.attr("xname").replace("inp", "");

        var others_altered = [];

        function cryo_processSearchAndFill_Process() {
            $btn.prop("disabled", "disabled");

            //como clicou no botão, cancela o timer que ira apagar o valor do campo
            clearTimeout(timeout);

            //tira a cor de preenchimento
            $container.removeClass("info");
            $container.removeClass("error");

            var qs = "";
            var c = $field.attr("data-c");
            var query = $field.val();

            //limpa todos os campos associados antes preenchidos
            others_altered = $field.attr("others_altered") != null ? $field.attr("others_altered").split(",") : [];
            $.each(others_altered, function (i, k) {
                cryo_fillValue(k, "", $field);
            });

            //mostra loading ajax
            if ($container.find(".loading").length == 0) {
                $container.append('<img src="../common/images/v3/loading_ajax.gif" style="height:16px;margin-top:5px" height="16" width="16" class="loading">');
            }

            var dependencies = [];

            if ($field.attr("data-dependencies") !== undefined) {
                dependencies = $field.attr("data-dependencies").split(",");
            }

            //monta queryString com valores das dependencias
            for (var j = 0; j < dependencies.length; j++) {
                if (qs != "") {
                    qs += "&";
                }

                var xname = "inp" + dependencies[j];
                var xvalue = $("form").find("[xname='" + xname + "']").length == 1 ?
                    $("form").find("[xname='" + xname + "']").val() :
                    $field.parents("tr").find("[xname='" + xname + "']").val();

                if (xvalue == null)
                    xvalue = "";

                qs += xname + "=" + xvalue;
            }

            //consulta a fonte de dados
            $.ajax({
                type: "post",
                dataType: "json",
                url: "../api/internal/legacy/1.0/datasource/get/1.0/" + c,
                data: (qs != "" ? "&" + qs : "") + "&f=" + query
            })
                .done(function (data) {
                    if (data.success != null) {
                        var found = false;

                        //para cada item de retorno
                        $.each(data.success, function (i, item) {
                            //se o texto é igual ao texto pesquisado ou não tem texto de retorno para pesquisar
                            if (!found && (item.txt.toLowerCase() == "" || item.txt.toLowerCase() == query.toLowerCase())) {
                                found = true;

                                //preencha aqui o valor do campo codigo (cod+identificador)
                                cryo_fillValue(key_to_codfield, item.cod, $field);

                                //para cada campo associado
                                $.each(item.fields, function (k, v) {
                                    if ("inp" + k != $field.attr("xname")) {
                                        //FillValue(cod, v);
                                        cryo_fillValue(k, v, $field);

                                        if ($.inArray(k, others_altered) == -1) {
                                            others_altered.push(k)
                                        }
                                    }
                                });
                                $field.attr("others_altered", others_altered);
                            }
                        });
                        //não achou nada procurado, mostra mensagem amigavel de erro
                        if (!found) {
                            $field.val('');
                            $field.trigger("change");
                            $container.addClass("error");

                            //limpa todos os campos associados antes preenchidos
                            others_altered = $field.attr("others_altered") != null ? $field.attr("others_altered").split(",") : [];
                            $.each(others_altered, function (i, k) {
                                cryo_fillValue(k, "", $field);
                            });
                        }
                    } else if (data.error != null) {
                        cryo_processSearchAndFilError(label, data.error.FriendlyMessage);
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    cryo_processSearchAndFilError(label, errorThrown);
                })
                .always(function () {
                    $container.find(".loading").remove();
                    $btn.prop("disabled", "");
                });
        }

        //ao clicar no botão ao lado do elemento
        $btn.off("click.processSearchAndFill").on("click.processSearchAndFill", cryo_processSearchAndFill_Process);

        $field.off("keypress.processSearchAndFill").on("keypress.processSearchAndFill", function (event) {
            if ($field.val() != "") {
                $container.addClass("info");
            }
        });

        //Salvar valor antes da possivel alteracao para ser comparado e utilizado na operacao de blur
        $field.off("focusin.processSearchAndFill").on("focusin.processSearchAndFill", function () {
            $(this).attr('old-value', $(this).val());
        });

        //ao tirar o foco do campo
        $field.off("blur.processSearchAndFill").on("blur.processSearchAndFill", function () {
            if ($field.val() != $field.attr("old-value")) {
                //espera 5 segundos para apagar o conteudo
                timeout = setTimeout(function () {
                    //limpa todos os campos associados antes preenchidos
                    var others_altered = $field.attr("others_altered") != null ? $field.attr("others_altered").split(",") : [];
                    $.each(others_altered, function (i, k) {
                        cryo_fillValue(k, "", $field);
                    });
                    $container.removeClass("info");
                }, 3000);
            }
        });

        $field.off("focus.processSearchAndFill").on("focus.processSearchAndFill", function () {
            $container.removeClass("error");
            clearTimeout(timeout);
        });
    });
}

//Trata-se de uma nova implementacao da FillValue.
//key: é o identificador (string) do campo do formulario
//v: é o valor a ser preenchido
//$origin: é o campo original que esta promovendo a alteração do campo key
function cryo_fillValue(key, v, $origin, fromcache) {
    fromcache = fromcache || false;
    var $form_root = $("form");
    var $row_root = $origin.parents("tr");

    var $field = $form_root.find("[xname='inp" + key + "']");
    var $div = $form_root.find("[xid='div" + key + "']");

    if ($field.length > 0) {
        //multivalorada
        if ($field.length > 1) {
            $field = $row_root.find("[xname='inp" + key + "']");
            $div = $row_root.find("[xid='div" + key + "']");
        }
        if (fromcache) {
            $field.attr("data-from-cache", true);
            $div.attr("data-from-cache", true);
        }
        $field.val(v).trigger("change");//.trigger("change.processFillOthers");
        $div.text(v);
    }
}

function generateAccessKey() {
    var selector = '#controllers button';

    function accesskeyAvailable(accesskey) {
        return $(selector).map(function () { return $(this).attr('accesskey') }).get().indexOf(accesskey) == -1;
    }

    $(selector).each(function (i, o) {
        var accesskey, label, foundAccessKey;

        foundAccessKey = false;

        label = $(o).html().toLowerCase();

        for (var i = 0; i < label.length && !foundAccessKey; i++) {
            accesskey = cryo_translateChars(label).substr(i, 1);

            if (accesskeyAvailable(accesskey)) {
                foundAccessKey = true;
            }
        }

        if ($(o).attr('accesskey') === undefined) {
            $(o).attr('accesskey', accesskey);
        }
    });
    cryo_UnderlineAccessKey();
};

function showOrHideControllerBlock(show) {
    if (show !== undefined && show === true) {
        // botoes de finalizacao
        document.querySelectorAll('#controllers button').forEach((btn) => { btn.disabled = false; });
        // botoes do colorbox de confirmacao de finalizacao
        document.querySelectorAll('div.cryo-confirm-dialog button.btn-primary').forEach((btn) => { btn.disabled = false; });
    } else {
        document.querySelectorAll('#controllers button').forEach((btn) => { btn.disabled = true; });
        document.querySelectorAll('div.cryo-confirm-dialog button.btn-primary').forEach((btn) => { btn.disabled = true; });
    }
}

// 18/01/2017 - Leonardo Luzzatto - Melhoria 30814
// Modificado para chamar uma funcao que executa a exibicao dos botoes de finalizacao
// Escoder os botoes de finalizacao de tarefa durante o processamento
function hideControllerBlock() {
    showOrHideControllerBlock();
}

// Exibe os botoes de finalizacao de tarefa durante o processamento
function showControllerBlock() {
    showOrHideControllerBlock(true);
}

function verifyCheckList() {
    var checkListBox = $("#BoxConclusionChecklist input[type='checkbox']");

    for (var i = 0; i < checkListBox.length; i++) {
        if (!checkListBox[i].checked) {
            cryo_alert($("#inpCodFlowExecute").val() === "" ? mMsgChecklistIncompleteStart : mMsgChecklistIncomplete);
            return false;
        }
    }

    return true;
}

function getExecutionMode() {
    return document.getElementById("inpDsExecutionMode").value;
}

function getExecutionPage() {
    let url = `../${getExecutionMode()}/execute`;
    if (window.location.pathname.indexOf("anonymous") > 0)
        url += "-anonymous";
    return url;
}